namespace cdh.utils {

    type storageListenerReg = {
        key: string | { (key: string): boolean }, action: Function
    } & IDisposable;
    const storageListeners: {
        storage: Storage,
        listeners: storageListenerReg[]
    }[] = [];

    var routes: { [route: string]: RouteJs.Route } = {};

    const tknKey = "reqTkn"
    var tkns: {
        relUrl: string,
        name: string,
        value: string
    }[] = [];

    let coll: Intl.Collator;
    if (Intl && Intl.Collator) {
        coll = new Intl.Collator(undefined, { sensitivity: "base" });
    }

    var scheduledReloads: KnockoutReloadable<any>[] = [];
    document.addEventListener("visibilitychange", e => {
        if (!document.hidden) {
            let sr = scheduledReloads;
            scheduledReloads = [];

            sr.forEach(r => r.awaitResult());
        }
    });


    export function all<T>(...deferreds: PromiseLike<T>[]) {
        if (deferreds.length != 1) {
            return $.Deferred<T[]>(function (def) {
                $.when(...deferreds.map(d => d.then(v => v))).then(
                    (...args: T[]) => def.resolveWith(this, Array.prototype.slice.call(args)),
                    (...args: any[]) => def.rejectWith(this, Array.prototype.slice.call(args)));
            });
        }
        else
            return deferreds[0].then(v => [v], e => [e]) as PromiseLike<T[]>;
    }

    /**
     * Wait for all Promises to Finish, doesn't stop if one or more Promises are rejected,
     * Allways returns an Array with the results of the resolved Promises
     * @param deferreds Promises to await
     */
    export async function allWithFails<T>(...deferreds: PromiseLike<T>[]) {

        let errors: any[] = [];
        let results: T[] = [];

        let d2 = deferreds.map(p => p.then((v) => results.push(v), e => errors.push(e)));

        await $.when(...d2);

        return results;
    }


    /**
     * Generates a Route from the RouteTemplate and RouteData
     * @param resource Route Template
     * @param values Route Data
     */
    export function getUrl(resource: string, values?: any) {

        if (!resource)
            return null;

        var route = routes[resource];

        if (!route) {
            routes[resource] = route = new RouteJs.Route({ url: resource, defaults: {} })
        }

        var tmp = route.build(values);
        return tmp != null ? (Router.baseUrl + tmp) : null;
    }


    /**
     * Generates a Route from the RouteTemplate and RouteData
     * @param resource Route Template
     * @param values Route Data
     */
    export function getExtUrl(base: string, resource: string, values?: any) {

        if (!resource || typeof (base) !== "string")
            return null;

        var route = routes[resource];

        if (!route) {
            routes[resource] = route = new RouteJs.Route({ url: resource, defaults: {} })
        }

        if (base.charAt(base.length - 1) != "/")
            base = base + "/";


        var tmp = route.build(values);
        return tmp != null ? (base + tmp) : null;
    }

    /**
     * Adds or Updates a queryParameter of an URL
     * @param uri uri to change
     * @param key name of the queryParameter
     * @param value value of the queryParameter
     */
    export function updateUrlParameter(uri: string, key: string, value: any) {
        // remove the hash part before operating on the uri
        let i = uri.indexOf('#');
        let hash = i === -1 ? '' : uri.substr(i);
        uri = i === -1 ? uri : uri.substr(0, i);

        let re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
        let separator = uri.indexOf('?') !== -1 ? "&" : "?";

        if (!value) {
            // remove key-value pair if value is empty
            uri = uri.replace(new RegExp("([?&]?)" + key + "=[^&]*", "i"), '');
            if (uri.slice(-1) === '?') {
                uri = uri.slice(0, -1);
            }
            // replace first occurrence of & by ? if no ? is present
            if (uri.indexOf('?') === -1) uri = uri.replace(/&/, '?');
        } else if (uri.match(re)) {
            uri = uri.replace(re, '$1' + key + "=" + value + '$2');
        } else {
            uri = uri + separator + key + "=" + encodeURIComponent(value);
        }
        return uri + hash;
    };

    /**
     * Regular Expression for Parsing CultureCookies
     * Groups: 1= Culture (Full), 2= Culture (Parent), 3= UICulture (Full), 4= UICulture (Parent)
     */
    const cultureCookieRegex = /c=(([a-z]{2})(?:-[A-Z]{2})?)\|uic=(([a-z]{2})(?:-[A-Z]{2})?)/;

    /**
     * Get the Current Culture from the Cookie
     * @param cookieName Name of the Cookie
     */
    export function getCultureFromCookie(cookieName: string): [string, string, string, string] {
        var cookie = Cookies.get(cookieName);

        if (cookie) {
            var res = cultureCookieRegex.exec(cookie);

            if (res)
                return <[string, string, string, string]>res.slice(1, 5);
            else
                return null;
        }

    }

    export function setCultureCookie(cookieName: string, culture: string, uiCulture?: string) {
        if (!uiCulture)
            uiCulture = culture;

        var cookieVal = "c=" + culture + "|uic=" + uiCulture;

        var attr: Cookies.CookieAttributes = { expires: moment().add(30, "d").toDate(), sameSite: "lax" };

        if (location.protocol == "https:")
            attr.secure = true;

        Cookies.set(cookieName, cookieVal, attr);
    }


    //debugger;
    function storeTokens() {
        setSessionOptions(tknKey, tkns);
    }
    function loadTokens() {
        tkns = getSessionOptions(tknKey);
        if (!$.isArray(tkns))
            tkns = [];
    }
    loadTokens();
    addSessionOptionsListener(tknKey, loadTokens);

    export function setRequestVerificationToken(relUrl: string, headerName: string, headervalue: string) {

        if (!relUrl) return;

        var tkn = { relUrl: Router.baseUrl + relUrl, name: headerName, value: headervalue };

        var isChanged = false;
        var ix = tkns.findIndex(t => equalsIgnoreCase(t.relUrl, tkn.relUrl));
        if (ix != -1) {
            if (!tkn.value) {
                tkns.splice(ix, 1);
                isChanged = true;
            }
            else if (tkn.name != tkns[ix].name || tkn.value != tkns[ix].value) {
                tkns[ix] = tkn;
                isChanged = true;
            }
        }
        else if (tkn.value) {
            tkns.push(tkn);
            isChanged = true;
        }

        if (isChanged)
            storeTokens();
    }

    $(document).ajaxSend((e, xhr, s) => {

        if (equalsIgnoreCase(s.method, "GET"))
            return;

        var tkn = tkns.find(t => startsWithIgnoreCase(s.url, t.relUrl))

        if (tkn)
            xhr.setRequestHeader(tkn.name, tkn.value);
    });

    export function addRequestVerificationToken(data: MappableObject, url?: string) {
        var tkn = url ? tkns.find(t => startsWithIgnoreCase(url, t.relUrl)) : tkns[0];

        if (tkn) {
            data['__RequestVerificationToken'] = tkn.value;
        }
    }

    /**
     * Finds a (Constructor-)Function by Name
     * @param str Name of the Function/Type in the current scope
     * @param scope optional Scope to use instead
     */
    export function stringToFunction<T extends Function>(str: string, scope?: MappableObject): T {
        var arr = str.split(".");

        var fn = (scope || window || this);
        for (var i = 0, len = arr.length; i < len; i++) {
            fn = fn[arr[i]];
        }

        if (typeof fn !== "function") {
            throw new Error("function not found");
        }

        return fn;
    };

    // #region String Functions
    export function compareIgnoreCase(a: string, b: string): number {
        if (typeof a !== "string" || typeof b !== "string")
            return 0;

        if (coll)
            return coll.compare(a, b);
        else {
            a = a.toUpperCase();
            b = b.toUpperCase();

            if (a > b) return 1;
            else if (a < b) return -1;
            else return 0;
        }
    }

    export function equalsIgnoreCase<T extends string>(a: T, b: T): boolean;
    export function equalsIgnoreCase(a: string, b: string): boolean;
    export function equalsIgnoreCase(a: string, b: string) {
        if (typeof a !== "string" || typeof b !== "string")
            return false;

        if (coll)
            return coll.compare(a, b) === 0;
        else {
            a = a.toUpperCase();
            b = b.toUpperCase();

            return a === b;
        }
    }

    export function containsIgnoreCase(a: string, b: string) {
        if (typeof a !== "string" || typeof b !== "string" || a.length < b.length)
            return false;

        var _b = b.charAt(0);

        if (!coll) {
            _b = b.toUpperCase();
            b = b.toUpperCase();
        }

        for (var i = 0; i < a.length + 1 - b.length; i++) {
            var _a = a.charAt(i);
            if (coll) {
                if (coll.compare(_a, _b) == 0 && coll.compare(a.substr(i, b.length), b) == 0)
                    return true;
            }
            else {
                _a = _a.toUpperCase();
                if (_a == _b && a.substr(i, b.length).toUpperCase() == b)
                    return true;
            }
        }

        return false;

    }

    export function getIndexesIgnoreCase(a: string, b: string, allowOverlapping = false): number[] {
        if (typeof a !== "string" || typeof b !== "string" || a.length < b.length || b.length == 0)
            return [];

        var res: number[] = [];
        var _b = b.charAt(0);

        if (!coll) {
            _b = b.toUpperCase();
            b = b.toUpperCase();
        }

        for (var i = 0; i < a.length + 1 - b.length; i++) {
            var _a = a.charAt(i);
            if (coll) {
                if (coll.compare(_a, _b) == 0 && coll.compare(a.substr(i, b.length), b) == 0) {
                    res.push(i);
                    if (allowOverlapping !== true)
                        i += b.length - 1;
                }
            }
            else {
                _a = _a.toUpperCase();
                if (_a == _b && a.substr(i, b.length).toUpperCase() == b) {
                    res.push(i);
                    if (allowOverlapping !== true)
                        i += b.length - 1;
                }
            }
        }

        return res;

    }

    export function startsWithIgnoreCase(a: string, b: string) {
        if (typeof a !== "string" || typeof b !== "string" || a.length < b.length)
            return false;

        a = a.substr(0, b.length);

        return equalsIgnoreCase(a, b);
    }

    export function endsWithIgnoreCase(a: string, b: string) {
        if (typeof a !== "string" || typeof b !== "string" || a.length < b.length)
            return false;

        a = a.substr(a.length - b.length);

        return equalsIgnoreCase(a, b);
    }



    export function toCamelCase(string: string) {
        return firstToLowerCase(string);
    }

    export function firstToLowerCase(a: string): string {
        if (typeof a !== "string") return null;

        switch (a.length) {
            case 0: return a;
            case 1: return a.toLocaleLowerCase();
            default: return a.substr(0, 1).toLocaleLowerCase() + a.substr(1);
        }
    }

    export function firstToUpperCase(a: string): string {
        if (typeof a !== "string") return null;

        switch (a.length) {
            case 0: return a;
            case 1: return a.toLocaleUpperCase();
            default: return a.substr(0, 1).toLocaleUpperCase() + a.substr(1);
        }
    }

    // #endregion

    export function isSameElementOrDescendant(elm1: Element, elm2OrChild: Element) {
        let node: Node = elm2OrChild;
        while (node != null) {
            if (node == elm1) {
                return true;
            }
            node = node.parentNode;
        }
        return false;
    }

    /**
     * Applies a Mixin (Extends the prototype)
     * @param derivedCtor
     * @param baseCtors
     */
    export function applyMixins(derivedCtor: any, baseCtors: any[]) {
        baseCtors.forEach(baseCtor => {
            Object.getOwnPropertyNames(baseCtor.prototype).forEach(name => {
                derivedCtor.prototype[name] = baseCtor.prototype[name];
            });
        });
    }

    /**
     * Copies the properties of an object
     * @param obj
     */
    export function copy<T>(obj: T): T {
        let result = <T>{};

        for (let id in obj) {
            (<any>result)[id] = (<any>obj)[id];
        }

        return result
    }

    /**
     * Creates a new Object with properties from both objects
     * @param first
     * @param second
     */
    export function extend<T, U>(first: T, second: U): T & U {
        let result = <T & U>copy(first);

        for (let id in second) {
            if (!result.hasOwnProperty(id)) {
                (<any>result)[id] = (<any>second)[id];
            }
        }
        return result;
    }
    /**
     * Extends the First object with Properties from the second
     * @param first
     * @param second
     */
    export function extend2<T, U>(first: T, second: U): T & U {
        let result = <T & U>first;

        for (let id in second) {
            if (!result.hasOwnProperty(id)) {
                (<any>result)[id] = (<any>second)[id];
            }
        }
        return result;
    }

    /**
     * Checks whether an object is like a Promise (defines a then member)
     * @param p Object to Check
     */
    export function isPromiseLike<T>(p: T | PromiseLike<T>): p is PromiseLike<T> {
        return p != null && (<PromiseLike<T>>p).then !== undefined;
    }

    export class DelayedAction {
        private _currTimeout: number;
        private _isRunning: boolean = false;
        private _repeat: boolean = false;

        constructor(readonly action: { (): void }, public delay?: number) {

        }

        cancel() {
            if (this._currTimeout)
                clearTimeout(this._currTimeout);
            this._currTimeout = 0;
        }

        schedule() {
            if (this._isRunning) {
                this._repeat = true;
                return;
            }

            this.cancel();

            this._currTimeout = setTimeout(() => {
                this._currTimeout = 0;

                this.trigger();
            }, this.delay || 250);
        }

        trigger() {
            if (this._isRunning) {
                this._repeat = true;
                return;
            }
            this.cancel();

            if (this.action)
                do {
                    this._repeat = false;
                    this._isRunning = true;

                    try {
                        this.action();
                    }
                    finally {
                        this._isRunning = false;
                    }
                }
                while (this._repeat);
        }
    }

    export interface IProgress {
        readonly isRunning: KnockoutReadonlyObservable<boolean>;
        readonly value: KnockoutReadonlyObservable<number>;
        readonly max: ObservableOrValueReadonly<number>;
        readonly currentStep: KnockoutReadonlyObservable<string>;
        readonly percentage: KnockoutReadonlyComputed<number>;
    }

    export class DummyProgress implements IProgress {
        private _timeout: number;

        readonly isRunning = ko.observable<boolean>(false);
        readonly value = ko.observable<number>(0);
        readonly max = ko.observable(100);
        readonly currentStep = ko.pureComputed(() => ko.unwrap(this.getStepFor(this.value())));
        readonly percentage = ko.pureComputed(() => {
            var max = ko.unwrap(this.max);
            var val = ko.unwrap(this.value);

            if (max == null) return -1;
            else return val / max;
        });

        /**
         * @summary Titles of the Steps
         **/
        steps: { start: number, end?: number, text: ObservableOrValue<string> }[]

        private clearTimeout() {
            if (this._timeout != 0) {
                clearInterval(this._timeout);
                this._timeout = 0;
            }
        }

        start(dur?: number) {
            this.clearTimeout();

            dur = dur || 8;
            var prog = this;
            var max = ko.unwrap(this.max) || 100;
            var intervall = 250;
            var steps = (dur * 1000) / intervall;
            var step = max / Math.floor(steps);

            this._timeout = setInterval(() => {
                var nxt = prog.value() + step;
                if (nxt >= max) {
                    nxt = max;
                    prog.clearTimeout();
                }

                prog.value(nxt);


            }, intervall);
            this.value(0);

            this.isRunning(true);
        }

        stop() {
            this.clearTimeout();
            this.isRunning(false);
            this.value(0);
        }

        getStepFor(nxt: number) {
            var txt: ObservableOrValue<string> = null;
            var sArr = ko.unwrap(this.steps);
            if (sArr) {
                var s = sArr.reverse().find(p => (p.start == null || p.start <= nxt) && (p.end == null || p.end > nxt));
                if (s)
                    txt = s.text;
            }

            return txt;
        }

    }

    // #region Templates

    export async function isSameTemplate(template: PromiseLike<DialogTemplate> | DialogTemplate, template2: DialogTemplate) {
        if (!template2 || typeof template2 == "string")
            return false;

        var t1 = await (template);

        if (!t1) return true;
        if (typeof (t1) == "string") return false;

        return t1.type == template2.type && typeof (t1.value) == "string" && typeof (template2.value) == "string"
            && equalsIgnoreCase(t1.value, template2.value);
    }

    /**
     * Loads an Dialog(View-Template)
     * @param template Parameters for Loading the Template
     */
    export async function loadTemplate(template: PromiseLike<DialogTemplate> | DialogTemplate): Promise<string> {
        var tOptions = await template;

        // Q> Define Resolving/Caching for Templates

        if (typeof tOptions === "string")
            return tOptions;
        else if (tOptions != null && typeof tOptions === "object") {
            var val = tOptions.value;

            if (typeof val == "function")
                val = val();

            if (utils.isPromiseLike(val))
                val = await val;

            if (typeof val !== "string")
                throw new Error("Invalid Template Type");

            switch (tOptions.type) {
                case "url":
                    if (!val) throw new Error("template URL can't be empty");
                    // Q> Cache Templates (PartialViews)?
                    return $.get(val);
                case "id":
                    if (!val) throw new Error("template ID can't be empty");

                    if (!document.getElementById(val))
                        await resolveTemplate(val);

                    return "<!-- ko template: '" + val + "' --><!-- /ko -->";
                default:
                    return val;
            }
        }
        else
            return null;
    }

    export const templateGroups: Dictionary<string | { (group: string): string }> = {};
    export var defaultTemplateGroup: { (group: string): string }

    const pendingTemplateGroups: Dictionary<Promise<void>> = {};

    export function resolveTemplate(name: string, reload = false): Promise<void> {
        // The Names are something like "templates/<group>/<template>"
        // The "templates/" prefix and template name can be missing.
        // The Request will always append the whole group and can be omitted if the group is already present.

        let parts = name.split("/");
        let group: string = equalsIgnoreCase(parts[0], "templates") ? parts[1] : parts[0];

        if (!group) throw new Error("GroupName required");
        group = cdh.utils.firstToLowerCase(group);

        if (pendingTemplateGroups[group])
            return pendingTemplateGroups[group];

        let p = pendingTemplateGroups[group] = resolveCore();

        let action = () => delete pendingTemplateGroups[group];

        p.then(action, action);

        return p;

        async function resolveCore() {
            let gId = "templates/" + group;
            let gElm = document.getElementById(gId);
            if (reload || !gElm) {
                // TODO getURL for group
                let url = templateGroups[group] || defaultTemplateGroup;
                if (typeof url === "function")
                    url = url(group);

                if (url) {
                    let raw = await $.get(url);
                    let html = <Element[]>$.parseHTML(raw).filter(n => n.nodeType === Node.ELEMENT_NODE);


                    let root: Element = null;
                    // TODO
                    if (html.length == 1 && html[0].id == gId) {
                        root = html[0];
                    }
                    else {
                        root = document.createElement("div");
                        root.id = gId;
                        root.append(...html);
                    }

                    if (gElm)
                        gElm.replaceWith(root);
                    else {
                        let cnt = document.getElementById("templates");

                        if (!cnt) {
                            cnt = document.createElement("div");
                            cnt.classList.add("d-none");
                            cnt.id = "templates";

                            document.body.append(cnt);
                        }

                        cnt.append(root);
                    }

                }

            }
        }
    }

    // #endregion

    /**
     * Returns the Items of an Array or an array containing a default Value if the Array is empty
     * @param observable Observable or Array of Elements
     * @param defVal Default Item
     */
    export function defaultIfEmpty<T>(observable: ObservableOrValueReadonly<T[]>, defVal?: T) {
        if (defVal === undefined) defVal = null;

        var res = ko.unwrap(observable);

        if (!$.isArray(res) || !res.length)
            return [defVal];
        else return res;
    }

    /**
     * Moves a Position Up/Down
     * @param item Position to Move
     * * @param moveUp Value that evaluates to True for up, Value that evaluates to False for down
     */
    export function moveItem<T>(observable: KnockoutObservableArray<T>, item: T, moveUp?: boolean) {
        var i = observable.indexOf(item);

        var iStart = i - 1;
        var cntDelete = 2;
        var iItem1 = i;
        var iItem2 = i - 1;
        var array = observable();

        if (i === -1)
            return;
        if (moveUp) {
            if (i < 1) return;
        }
        else {
            if (i >= array.length)
                return;

            iStart = i;
            iItem1 = i + 1;
            iItem2 = i;
        }

        observable.splice(iStart, cntDelete, array[iItem1], array[iItem2]);

    };

    /**
     * Checks whether a Position can be moved Up/Down
     * @param item Position to Move
     * @param moveUp Value that evaluates to True for up, Value that evaluates to False for down
     */
    export function canMoveItem<T>(observable: KnockoutObservableArray<T>, item: T, moveUp?: boolean) {
        var array = observable();
        var i = array.indexOf(item);

        if (i === -1)
            return false;
        if (moveUp) {
            if (i < 1) return false;
        }
        else if (i >= array.length)
            return false;

        return true;

    };

    export function removeItem<T extends object>(observable: KnockoutObservableArray<T>, deleteFunc: (item: T) => Promise<boolean>, item: T | number) {
        if (item === undefined || item === null)
            return false;
        else {
            let self = this;

            if (typeof item === "number")
                item = observable()[item];

            if (observable.indexOf(item) == -1)
                return false;


            if (deleteFunc) {
                let tmp = item;
                deleteFunc(tmp).then(res => {
                    if (res === true)
                        observable.remove(tmp);
                });
            }
            else
                observable.remove(item);
        }
    }

    // #region Computed

    export function unpeek<T>(value: T | KnockoutReadonlyObservable<T>, peek = true) {
        if (ko.isSubscribable(value))
            return peek !== false ? value.peek() : value();
        else
            return value;
    }

    export function ctxGet<T = any>(ctx: KnockoutBindingContext, name: string) {
        if (ctx.$data && ctx.$data[name])
            return <T>ctx.$data[name];

        return (<Dictionary<T>><unknown>ctx)[name];
    }

    export interface IBusyCounter extends KnockoutReadonlyComputed<boolean> {
        title: KnockoutReadonlyComputed<string>;
        setBusy(promise: Promise<any>, title?: ObservableOrValueReadonly<string>): void;
        beginUsing(title?: ObservableOrValueReadonly<string>): IDisposable;

        addDependency(dep: KnockoutReadonlyObservable<boolean>): void;
        removeDependency(dep: KnockoutReadonlyObservable<boolean>): void;

        waitForIdle(): Promise<void>;// Q> Add Parameter for Timeout/Cancellation
    }

    export function createBusyCounter(...deps: KnockoutReadonlyObservable<boolean>[]): IBusyCounter {
        var loadObjArr = ko.observableArray<{ p: Promise<unknown> | IDisposable, t: ObservableOrValueReadonly<string> }>();
        var depsArr = ko.observableArray<KnockoutReadonlyObservable<boolean>>(deps);

        var setBusy = (handle: Promise<any>, title?: ObservableOrValueReadonly<string>) => {

            if (handle) {
                let obj = { p: handle, t: title }

                // Q> Push or unshift new item (insert at start or end of the Array)?
                loadObjArr.push(obj);

                handle.then(() => {
                    loadObjArr.remove(obj);
                }, () => {
                    loadObjArr.remove(obj);
                });
            }

        }
        var beginUsing = (title?: ObservableOrValueReadonly<string>): IDisposable => {
            var isDisposed = false;

            var obj: { p: IDisposable, t: ObservableOrValueReadonly<string> } = { p: null, t: title };
            var d = {
                dispose: () => {
                    if (!isDisposed) {
                        isDisposed = true;
                        loadObjArr.remove(obj);
                    }
                }, title
            };
            obj.p = d;

            // Q> Push or unshift new item (insert at start or end of the Array)?
            loadObjArr.push(obj);
            return d;
        }

        var res = ko.pureComputed(() => depsArr().some(d => ko.unwrap(d)) || loadObjArr().length > 0);
        var titleCmp = ko.pureComputed(() => {
            var res: string = null;
            var dep = depsArr().find(d => ko.unwrap(d));
            if (dep) {
                if ((dep as IBusyCounter).title)
                    res = ko.unwrap((dep as IBusyCounter).title);
            }
            else {
                var p = loadObjArr()[0];
                if (p)
                    res = ko.unwrap(p.t);
            }

            if (!res)
                res = t("Loading");

            return res;
        }).extend({ deferred: true });

        var waitForIdle = () => {
            if (!res()) return Promise.resolve();

            var p = $.Deferred();
            var sub = res.subscribe(v => {
                if (!v) {
                    sub.dispose();

                    p.resolve();
                }
            });

            return p;
        }

        return extend2(res, {
            title: titleCmp,
            setBusy,
            beginUsing,
            waitForIdle,
            addDependency: depsArr.push.bind(depsArr),
            removeDependency: depsArr.remove.bind(depsArr)
        });
    }

    export interface SuspendableObservable<T> extends KnockoutObservable<T> {
        readonly isSuspended: KnockoutObservable<boolean>;
        readonly source: KnockoutObservable<T>;
    }

    export function suspendableObservable<T>(target: KnockoutObservable<T>, suspendedObs?: KnockoutObservable<boolean>): SuspendableObservable<T> {

        if (!ko.isObservable(suspendedObs))
            suspendedObs = ko.observable(false);

        var curVal = target.peek();
        var res: KnockoutObservable<T> & Partial<{
            isSuspended: KnockoutObservable<boolean>, source: KnockoutObservable<T>
        }> = ko.computed({
            read: () => {
                if (!ko.unwrap(suspendedObs))
                    curVal = ko.unwrap(target);

                return curVal;
            },
            write: val => {
                if (!suspendedObs.peek())
                    target(val);
            }
        });

        res.isSuspended = suspendedObs;
        res.source = target;

        return res as any;
    }

    /**
     * Buffers an Observable to prevent changes while the Observable is being written
     * @param options Options for Creating the Observable.
     * @param deferred if false the observable won't use the deferred-Extender.
     */
    export function bufferedComputed<T>(options: KnockoutComputedDefine<T>, deferred?: boolean) {


        if (options != null || options.write != null) {
            let buffer: T = null;
            let isWriting = ko.observable(false);

            let read = options.read;
            let write = options.write;

            if (options.owner) {
                read = read.bind(options.owner);
                write = write.bind(options.owner);
            }

            options.read = () => {

                if (ko.unwrap(isWriting))
                    return buffer;
                else
                    return read();
            };
            options.write = val => {
                if (isWriting.peek()) return;

                buffer = val;
                isWriting(true);

                write(val);

                buffer = null;
                isWriting(false);
            }
        }
        var res = ko.computed(options);

        if (deferred !== false)
            res.extend({ deferred: true });

        return res;

    }

    export interface StagedObservableOptions<T> {
        baseObservable?: KnockoutObservable<T>;
        value?: T;
        updateOnBaseChanged?: boolean;
        coerceValue?: { (value: T): T };
        comparison?: { (a: T, b: T): boolean };
    }

    export interface StagedObservable<T> extends KnockoutObservable<T> {
        baseValue: KnockoutObservable<T>;
        isChanged: KnockoutReadonlyComputed<boolean>;
        reset(): void;
    }

    export function stagedObservable<T>(options: StagedObservableOptions<T>): StagedObservable<T> {
        options = options || {};

        var autoUpdate = options.updateOnBaseChanged !== false;

        var baseObs = options.baseObservable || ko.observable();

        if (autoUpdate)
            baseObs.extend({ notify: "always" });

        if (options.value === undefined)
            options.value = baseObs.peek();

        var curVal = ko.observable<T>(options.value);

        var result: Partial<StagedObservable<T>>;
        var disposables: IDisposable[] = [];

        {
            var tmp = ko.computed({
                read: () => {
                    var val = curVal();

                    if (options.coerceValue)
                        val = options.coerceValue(val);

                    return val;
                },
                write: curVal
            }).extend({ deferEvaluation: true });

            var d = tmp.dispose;

            if (autoUpdate)
                disposables.push(baseObs.subscribe(v => curVal(v)));

            tmp.dispose = () => {
                disposables.forEach(d => d.dispose());
                d();
            }

            result = tmp;
        }

        result.baseValue = baseObs;

        var isChanged: KnockoutComputed<boolean>;
        if (options.comparison)
            isChanged = ko.pureComputed(() => options.comparison(ko.unwrap(baseObs), ko.unwrap(curVal)));
        else
            isChanged = ko.pureComputed(() => ko.unwrap(baseObs) !== ko.unwrap(curVal));
        disposables.push(isChanged);

        result.isChanged = isChanged;
        result.reset = () => curVal(baseObs());

        return <any>result;
    }

    export function isStagedObservable<T>(obs: KnockoutObservable<T>): obs is StagedObservable<T>;
    export function isStagedObservable(obs: any): obs is StagedObservable<any>;
    export function isStagedObservable(obs: any): obs is StagedObservable<any> {
        return ko.isObservable(obs) && ko.isWriteableObservable((<StagedObservable<any>>obs).baseValue);
    }

    export function stagedChanged(...observables: ObservableOrValue<any>[]) {
        return ko.pureComputed(() => observables.some(o => isStagedObservable(o) && o.isChanged()));
    }

    export function mergedTextObservable(t1: KnockoutObservable<string>, t2: KnockoutObservable<string>, length: number): KnockoutComputed<string>;
    export function mergedTextObservable(t1: KnockoutObservable<string>, t2: KnockoutObservable<string>, length1: number, length2: number): KnockoutComputed<string>;
    export function mergedTextObservable(t1: KnockoutObservable<string>, t2: KnockoutObservable<string>, separator: string, length: number): KnockoutComputed<string>;
    export function mergedTextObservable(t1: KnockoutObservable<string>, t2: KnockoutObservable<string>, separator: string, length1: number, length2: number): KnockoutComputed<string>;
    export function mergedTextObservable(t1: KnockoutObservable<string>, t2: KnockoutObservable<string>, ...args: any[]) {
        let sep = "";
        let l1 = -1;
        let l = -1;

        {
            let l2 = -1;
            args.forEach(arg => {
                if (typeof (arg) === "string")
                    sep = arg;
                else if (typeof (arg) === "number")
                    if (l1 == -1)
                        l1 = arg;
                    else
                        l2 = arg;
            });

            if (l2 == -1)
                l2 = l1;

            if (l1 !== -1 && l2 != -1)
                l = l1 + l2;
        }

        return bufferedComputed({
            read: () => ko.unwrap(t1) + sep + ko.unwrap(t2),
            write: (v) => {

                v = String(v);

                if (!v) {
                    t1("");
                    t2("");
                }
                else if (v.length <= l1) {
                    t1(v);
                    t2("");
                }
                else if (v.length > l)
                    throw "Text to long";
                else {
                    t1(v.substr(0, l1));
                    t2(v.substr(l1));
                }
            }
        });
    }

    export function tokenizedTextObservable(t1: KnockoutObservable<string>, t2: KnockoutObservable<string>) {

        const splitPoint = 30;
        const delim = " ";
        // TODO Check Tokenization Logic

        return bufferedComputed({
            read: () => {
                let s1 = ko.unwrap(t1);
                let s2 = ko.unwrap(t2);

                if (s1)
                    if (s2)
                        return s1 + delim + s2;
                    else
                        return s1;
                else
                    if (s2)
                        return s2;
                    else
                        return null;

            },
            write: str => {
                let part1: string, part2: string;

                if (str != null) {
                    str = String(str);

                    if (str.length <= 30) {
                        part1 = str;
                        part2 = null;
                    }
                    else {
                        let ix = str.indexOf(delim);

                        if (ix == -1 || ix >= splitPoint) {
                            part1 = str.substr(0, 30);
                            part2 = str.substr(30, 30);
                        }
                        else {
                            let tmpIx: number = ix;
                            while (tmpIx != -1 && tmpIx < splitPoint) {
                                ix = tmpIx;
                                tmpIx = str.indexOf(delim, ix + 1);
                            }

                            part1 = str.substr(0, ix);
                            part2 = str.substr(ix + 1, splitPoint);

                        }
                    }

                }

                t1(part1);
                t2(part2);
            }
        });
    }


    export function getFlag(flags: ObservableOrValue<number>, mask: number): boolean {
        return (ko.unwrap(flags) & mask) == mask;
    }
    export function setFlag(flags: ObservableOrValue<number>, mask: number, value?: boolean): number {
        var res = ko.unwrap(flags);

        if (value != false) {
            res |= mask;
        }
        else {
            res &= ~mask;
        }

        return res;
    }

    export function computedFlag(flags: KnockoutObservable<number>, mask: number, writeable: false): KnockoutReadonlyComputed<boolean>;
    export function computedFlag(flags: KnockoutObservable<number>, mask: number, writeable?: boolean): KnockoutComputed<boolean>;
    export function computedFlag(flags: KnockoutObservable<number>, mask: number, writeable?: boolean) {
        var def: KnockoutComputedDefine<boolean> = {
            read: () => getFlag(flags, mask)
        };

        if (ko.isWriteableObservable(flags) && writeable !== false)
            def.write = val => flags(setFlag(flags, mask, val));

        return ko.pureComputed(def); // Q> Deferred?
    }


    // Q> Create class that also Implements KnockoutAsyncInternalState
    export function getAsyncFunctions<T>(state: KnockoutAsyncInternalState<T>) {

        var awaitResult = () => {
            var def = $.Deferred<T>();

            if (!state.isLoading())
                def.resolve(state.value());
            else {
                var s = state.isLoading.subscribe(v => {
                    if (v) return;

                    s.dispose();
                    def.resolve(state.value());
                })
            }

            return def.promise();
        };

        var setLoading = (s: boolean, p?: PromiseLike<T>) => {
            if (state.currentPromise && state.currentPromise != p) {
                if (typeof state.currentPromise.abort == "function")
                    state.currentPromise.abort;
                state.currentPromise = null;
            }

            state.isLoading(s);

        }

        var setResult = (value: T | PromiseLike<T>, clearValue?: boolean) => {

            if (isPromiseLike(value)) {
                setLoading(true, value);
                state.currentPromise = value;
                if (clearValue !== false)
                    state.value(null);

                value.then(v => {
                    if (value != state.currentPromise) return;
                    setResult(v);
                }, err => {
                    if (value != state.currentPromise) return;
                    setResult(null);

                    // TODO Error Handling
                    if (state.onError)
                        state.onError(err);
                });
            }
            else {
                state.currentPromise = null;
                state.value(value);
                setLoading(false);
            }
        };


        return {
            awaitResult: awaitResult,
            setLoading: setLoading,
            setResult: setResult,
        };
    }

    function getReloadFunction<T>(reloadFunc: (() => Promise<T> | T) | string, defValue?: (() => T) | T) {
        var _rf: () => Promise<T> | T;

        if (typeof (reloadFunc) === "string") {
            let url = reloadFunc;
            _rf = () => utils.getSingle(url);
        }
        else if (reloadFunc)
            _rf = reloadFunc;
        else
            _rf = () => typeof defValue == "function" ? (defValue as any)() : defValue;

        return _rf;
    }

    export class AsyncComputedInternalState<T> implements KnockoutAsyncInternalState<T>, KnockoutAsyncFunction<T> {
        readonly value: KnockoutObservable<T>;
        readonly isLoading: KnockoutObservable<boolean>;
        currentPromise?: PromiseLike<T> & Partial<{ abort(): void; }>;
        onError?: (reason: any) => void;

        readonly awaitResult: () => PromiseLike<T>;
        readonly setLoading: (s: boolean, p?: PromiseLike<T>) => void;
        readonly setResult: (value: T | PromiseLike<T>, clearValue?: boolean) => void;

        constructor(value: ObservableOrValue<T>) {
            if (ko.isWriteableObservable(value))
                this.value = value;
            else
                this.value = ko.observable(ko.unwrap(value));
            this.isLoading = ko.observable(false);

            extend2(this, getAsyncFunctions(this));
        }
    }

    /**
     * Creates a computed Observable that holds the result of an asynchronous Operation
     * @param evaluator Delegate used to Evaluate the Operation may return a Value or a Promise
     * @param owner Object used as 'this' when calling the evaluator
     * @param deferred
     */
    export function asyncComputed<T>(evaluator: () => Promise<T> | T, owner?: any, deferred?: boolean): KnockoutAsyncComputed<T> {
        let result: KnockoutObservable<T> & Mutable<Partial<KnockoutAsyncFunction<T> & IDisposable>> = ko.observable<T>();

        var state = new AsyncComputedInternalState(result);
        result.isLoading = state.isLoading;

        result.awaitResult = state.awaitResult;

        var cmp = ko.computed(() => {
            var tmp = evaluator.call(owner);

            state.setResult(tmp);
        });

        if (deferred !== false)
            cmp.extend({ deferred: true });

        var d = result.dispose;
        result.dispose = () => {
            if (d) d();
            cmp.dispose();
        };

        return result as KnockoutAsyncComputed<T>;
    }

    /**
     * Creates a computed Observable that holds the result of an asynchronous Operation
     * @param evaluator Delegate used to Evaluate the Operation may return a Value or a Promise
     * @param owner Object used as 'this' when calling the evaluator
     * @param deferred
     * @description Other than asyncComputed the Computed created with this function may not hold an value if the observable has no subscriptions.
     */
    export function asyncComputed2<T>(evaluator: () => Promise<T> | T, owner?: any, deferred?: boolean): KnockoutAsyncComputed<T> {
        return asyncComputed3({ evaluator: evaluator, owner: owner, deferred: deferred });
    }

    export function asyncComputed3<T, TOwner = any>(options?: KnockoutAsyncComputedOptions<T, TOwner>): KnockoutAsyncComputed<T> {

        var state = new AsyncComputedInternalState(ko.observable<T>());
        let started = ko.observable(false);

        let result: KnockoutReadonlyComputed<T> & Mutable<Partial<KnockoutAsyncFunction<T> & IDisposable>> = ko.pureComputed<T>(() => {
            started(true);
            return ko.unwrap(state.value);
        });

        if (options.onError)
            state.onError = (err) => options.onError(state, err);

        result.isLoading = state.isLoading;
        result.awaitResult = state.awaitResult;

        var evaluator = options.evaluator;
        var owner = options.owner;
        var defFunc = options.default || (() => null);
        var reset = options.resetWhileLoading !== false;
        var deferred = options.deferred !== false;

        var cmp = ko.computed(() => {

            // Deactivate the evaluation if the Computed has no Subscriptions.
            started(result.getSubscriptionsCount() != 0);

            var tmp: T | Promise<T>;

            if (ko.unwrap(started)) {
                tmp = evaluator.call(owner);
            }
            else
                tmp = defFunc();

            if (isPromiseLike(tmp)) {
                if (reset)
                    state.setResult(defFunc(), true);
                state.setResult(tmp, false);
            }
            else
                state.setResult(tmp, true);

        });

        if (deferred !== false)
            cmp.extend({ deferred: true });

        var d = result.dispose;
        result.dispose = () => {
            if (d) d();
            cmp.dispose();
        };

        return result as KnockoutAsyncComputed<T>;
    }

    /**
     * Creates a computed Observable that holds the result of an deferred asynchronous Operation with a manual reload-Trigger.
     * @param reloadFunc Function that is invoked when (re)loading the Data
     * @param defValue Default/Fallback Value
     */
    export function asyncReloadable<T>(reloadFunc: (() => Promise<T> | T) | string, defValue?: T | KnockoutObservable<T>): KnockoutReloadable<T> {

        var obs = ko.isObservable(defValue) ? defValue : ko.observable(defValue);

        var st = new utils.AsyncComputedInternalState(obs);
        var _isLoaded = false;

        var _rf = getReloadFunction(reloadFunc, defValue);

        var reload = async () => {
            _isLoaded = true;
            st.setResult(await _rf());
        }

        return utils.extend2(ko.pureComputed(() => {
            if (!_isLoaded) reload();

            return st.value();
        }), { isLoading: st.isLoading, reload: reload, awaitResult: st.awaitResult });
    }

    export type CacheOptions<T> = {
        reloadFunc: (() => Promise<T> | T) | string,
        storage?: string | CacheStorageOptions<T>,
        duration?: number,
        defValue?: T,
        writeable?: boolean,
    };
    export type WritableCacheOptions<T> = CacheOptions<T> & { writeable: true };
    export type CacheStorageOptions<T> = {
        name: string,
        setData?: (cData: CacheData<T>) => void,
        checkData?: (cData: CacheData<T>) => boolean
    };
    export type CacheData<T> = {
        data: T,
        time: string
    } & MappableObject


    export function asyncCacheable<T>(cacheOptions: WritableCacheOptions<T>): KnockoutReloadable<T> & KnockoutComputed<T>;
    export function asyncCacheable<T>(cacheOptions: CacheOptions<T>): KnockoutReloadable<T>;
    export function asyncCacheable<T, TExt>(cacheOptions: WritableCacheOptions<T>, extFunc: (target: KnockoutReadonlyObservable<T>) => TExt): KnockoutReloadable<T> & TExt & KnockoutComputed<T>;
    export function asyncCacheable<T, TExt>(cacheOptions: CacheOptions<T>, extFunc: (target: KnockoutReadonlyObservable<T>) => TExt): KnockoutReloadable<T> & TExt;
    export function asyncCacheable<T, TExt = void>(cacheOptions: CacheOptions<T>, extFunc?: (target: KnockoutReadonlyObservable<T>) => TExt): KnockoutReloadable<T> & TExt {

        var _rf = getReloadFunction(cacheOptions.reloadFunc, cacheOptions.defValue);
        let dur = cacheOptions.duration || 5;
        var st: CacheStorageOptions<T>;

        let key = "CacheableObservable";

        let _lastCheck = ko.observable<moment.Moment>();
        let _p: Promise<T> | T;
        let obs = ko.observable<T>();
        let isLoading = ko.observable(false);
        let isFirst = true;
        var ivCallback: number = 0;

        if (cacheOptions.storage) {
            if (typeof cacheOptions.storage === "string")
                st = { name: cacheOptions.storage };
            else
                st = cacheOptions.storage;

            key += "[" + st.name + "]";
        }

        let cmpDef: KnockoutComputedDefine<T> = {
            read() {
                getResultFunc();

                return obs();
            }
        }

        if (cacheOptions.writeable)
            cmpDef.write = async v => {
                isLoading(true);
                let m = moment();

                //console.log(key, "Begin Write");
                let p2 = _p = v;
                _lastCheck(m);

                // Q> Error Handling?
                let val = await _p;
                if (_p === p2) {
                    _p = v;
                    obs(v);

                    if (st) {
                        let cData: CacheData<T> = { data: v, time: m.toJSON() };
                        if (st.setData)
                            st.setData(cData);
                        setSessionOptions(st.name, cData);
                    }
                    isLoading(false);
                }
            }

        let resObs: any = ko.pureComputed(cmpDef).extend({ deferred: true, deferEvaluation: true });

        resObs = extend2(resObs, {
            isLoading,
            awaitResult: getResultFunc,
            reload: reloadFunc
        }) as KnockoutReloadable<T>;

        if (dur > 0) {
            _lastCheck.subscribe(m => {
                if (ivCallback != 0) {
                    clearTimeout(ivCallback);
                    ivCallback = 0;
                }
                if (checkDateFunc(m)) {
                    let end = m.clone().add(dur, "minutes");
                    let time = end.diff(moment(), "milliseconds", true);
                    time = Math.max(time, 50);
                    //console.log(key, "Set Reload Timeout", time);
                    let c = ivCallback = setTimeout(() => {
                        if (ivCallback == c) ivCallback = 0;

                        if (document.hidden) scheduledReloads.push(resObs);
                        else
                            getResultFunc();
                    }, time);
                }
            });
        }

        if (extFunc) {
            let extObj = extFunc(resObs);
            if (extObj && extObj as any !== resObs)
                extend2(resObs, extObj);
        }

        return resObs;

        function checkDateFunc(cd: string | moment.Moment) {
            if (typeof cd == "string")
                cd = moment(cd);

            if (moment.isMoment(cd) && cd.isValid()) {
                return dur <= 0 || moment().diff(cd, "minutes") < dur;
            }
            return false;
        }
        async function reloadFunc() {
            isLoading(true);
            let m = moment();

            //console.log(key, "Begin Reload");
            let p2 = _p = _rf();
            _lastCheck(m);

            // Q> Error Handling?
            let val = await _p;
            if (_p === p2) {
                _p = val;
                obs(val);

                if (st) {
                    let cData: CacheData<T> = { data: val, time: m.toJSON() };
                    if (st.setData)
                        st.setData(cData);
                    setSessionOptions(st.name, cData);
                }
                isLoading(false);
            }
            // Q> return val;
        };
        async function getResultFunc() {
            if (isFirst) {
                isFirst = false;
                if (st) {
                    loadCacheData();
                    addSessionOptionsListener(st.name, loadCacheData);
                }
            }

            if (!checkDateFunc(_lastCheck())) {
                await reloadFunc();
            }

            return await _p;
        }
        function loadCacheData() {
            let cData = getSessionOptions<CacheData<T>>(st.name);
            if (cData) {
                let lc = moment(cData.time);
                if ((checkDateFunc(lc) || !_lastCheck.peek()) && (!st.checkData || st.checkData(cData))) {
                    //console.log(key, "Load from Storage", cData.data);
                    _p = cData.data;
                    _lastCheck(lc);
                    obs(cData.data);
                }
            }
        };

    }


    type DictArrPrepItem<TKey, TElement> = { key: TKey, keyString: string, element: TElement };
    type DictArrItem<TKey, TElement> = { key: TKey, keyString: string, element: KnockoutObservable<TElement> };
    type DictItem<TElement> = { ix: number, item: KnockoutObservable<TElement> };

    export interface IReadonlyDictionary<TKey, TElement> {

        getAll(): TElement[];
        getKeys(): TKey[];
        getPairs(): KeyValuePair<TKey, TElement>[];
        get(key: TKey): TElement;
        tryGet(key: TKey): [boolean, TElement];

        peek: (k: TKey) => TElement;
        peekAll: { (): TElement[]; };
        peekPairs: { (): KeyValuePair<TKey, TElement>[]; };
        peekKeys: () => TKey[];

    }

    export interface IDictionary<TKey, TElement> extends IReadonlyDictionary<TKey, TElement> {
        add(key: TKey, element: TElement, overwrite?: boolean): void;
        remove(key: TKey): void;
        clear(): void;
    }

    export interface IKeyedCollection<TKey, TElement> extends IReadonlyDictionary<TKey, TElement> {
        getKey(element: TElement): TKey;
        add(element: TElement, overwrite?: boolean): void;
        remove(key: TKey): void;
        clear(): void;
    }

    export interface DictionaryCollectionOptions<TKey, TElement> {
        normalizeKey?: (ks: string) => string;
        convertKey?: (key: TKey) => string;
    }

    export interface ViewModelDictionaryCollectionOptions<TKey, TModel, TViewModel> extends DictionaryCollectionOptions<TKey, TViewModel> {

        getKey: (model: TModel) => TKey | false;
        createViewModel: (model: TModel) => TViewModel;
        updateViewModel?: (vm: TViewModel, model: TModel) => void;

        getModel: (vm: TViewModel) => TModel;

    }

    export function pairsToObject<TValue>(pairs: KeyValuePair<string, TValue>[], keyFunc?: (key: string) => string): Dictionary<TValue>
    export function pairsToObject<TKey, TValue>(pairs: KeyValuePair<TKey, TValue>[], keyFunc: (key: TKey) => string): Dictionary<TValue>
    export function pairsToObject<TKey, TValue>(pairs: KeyValuePair<TKey, TValue>[], keyFunc?: (key: TKey) => string): Dictionary<TValue> {
        var obj: Dictionary<TValue> = {};

        if ($.isArray(pairs))
            pairs.forEach(p => {
                var k = keyFunc ? keyFunc(p.key) : p.key;

                if (typeof (k) == "string")
                    obj[k] = p.value;
            });

        return obj;
    }

    export class DictionaryCollection<TKey, TElement, TOptions extends DictionaryCollectionOptions<TKey, TElement> = DictionaryCollectionOptions<TKey, TElement>> {

        protected readonly collObs = ko.observableArray<DictArrItem<TKey, TElement>>();
        protected readonly itemsDict: KnockoutReadonlyObservable<Dictionary<DictItem<TElement>>>;

        constructor(protected readonly options: TOptions) {
            //this.itemsDict = ko.computed<Dictionary<{ ix: number, item: KnockoutObservable<TElement> }>>(this.getDict, this).extend({ deferred: true });

            this.itemsDict = DictionaryCollection.getDict2(this.collObs);

        }

        private getDict(): Dictionary<DictItem<TElement>> {
            var res: Dictionary<DictItem<TElement>> = {};

            this.collObs().forEach((v, i) => {
                if (res[v.keyString] === undefined) {
                    res[v.keyString] = { item: v.element, ix: i };
                }
            });

            return res;

        }

        private static getDict2<TKey, TElement>(collObs: KnockoutObservableArray<DictArrItem<TKey, TElement>>): KnockoutReadonlyObservable<Dictionary<DictItem<TElement>>> {
            var res: Dictionary<DictItem<TElement>> = {};
            var cmp = ko.observable<Dictionary<DictItem<TElement>>>(res).extend({ deferred: true });

            var s = collObs.subscribe(newVal => {
                for (var key in res)
                    delete res[key];

                newVal.forEach((v, i) => {
                    if (res[v.keyString] === undefined) {
                        res[v.keyString] = { item: v.element, ix: i };
                    }
                });

                cmp(res);
            });

            //cmp.dispose = () => s.dispose();

            return cmp;
        }


        protected getEntry(key: TKey, dict?: Dictionary<DictItem<TElement>>): [boolean, DictItem<TElement>, string, Dictionary<DictItem<TElement>>] {

            var result = false;
            var ks = this.keyFunc(key);
            var entry: DictItem<TElement> = null;

            if (ks) {
                if (!dict) dict = this.itemsDict.peek();

                entry = dict[ks];
                if (entry) {
                    result = true;
                }
            }

            return [result, entry, ks, dict];
        }

        keyFunc(key: TKey): string {
            var ks: string = null;
            if (this.options.convertKey)
                ks = this.options.convertKey(key);
            else {
                if (key != null)
                    ks = String(key);
            }

            if (this.options.normalizeKey)
                ks = this.options.normalizeKey(ks);
            else {
                if (typeof ks == "string")
                    ks = ks.toUpperCase();
            }

            return ks;
        }

        add(key: TKey, element: TElement, overwrite = false) {

            var [exists, entry, ks] = this.getEntry(key);

            if (exists) {
                if (overwrite) {
                    entry.item(element);
                    this.collObs.valueHasMutated();
                }
                else
                    throw new Error("Duplicate Key");
            }
            else if (ks != null)
                this.collObs.push({ key: key, keyString: ks, element: ko.observable(element) });
            else
                throw new Error("Key is required");
        }

        addMultiple(...items: { key: TKey, element: TElement }[]) {
            let dict = this.itemsDict.peek();
            let pushItems: DictArrItem<TKey, TElement>[] = [];

            let tmpKeys: Dictionary<true> = {};

            for (var i = 0; i < items.length; i++) {
                var { key, element } = items[i];
                var [exists, entry, ks] = this.getEntry(key, dict);

                if (ks == null) throw new Error("Key can't be empty");
                if (exists || tmpKeys[ks]) throw new Error("Duplicate Key");

                pushItems.push({ key, keyString: ks, element: ko.observable(element) });
                tmpKeys[ks] = true;
            }

            if (pushItems.length)
                this.collObs.push(...pushItems);
        }

        remove(key: TKey) {

            var [exists, entry] = this.getEntry(key);

            if (exists) {
                this.collObs.splice(entry.ix, 1);
                if (entry.item.getSubscriptionsCount()) {
                    if (entry.item.peek() != null)
                        entry.item(null);
                    else
                        entry.item.notifySubscribers(null);
                }
            }
        }

        clear() {
            var curItems = this.collObs.peek().slice();
            this.collObs.removeAll();

            curItems.forEach(i => {
                if (i.element.getSubscriptionsCount()) {
                    if (i.element.peek() != null)
                        i.element(null);
                    else
                        i.element.notifySubscribers(null);
                }
            });
        }

        // Create one Method for getting all Elements and for getting a specific Element
        // And a Parameters for the Resulttype and whether to peek or not.

        getAll2(type?: "values", peek?: boolean): TElement[];
        getAll2(type: "keys", peek?: boolean): TKey[];
        getAll2(type: "pairs", peek?: boolean): KeyValuePair<TKey, TElement>[];
        getAll2(type: "values" | "keys" | "pairs" = "values", peek?: boolean) {
            var vals = peek ? this.collObs.peek() : this.collObs();

            if (type == "keys")
                return vals.map(v => v.key);
            else if (type == "pairs")
                return vals.map(v => ({ key: v.key, value: peek ? v.element.peek() : ko.unwrap(v.element) }));
            else
                return vals.map(v => peek ? v.element.peek() : ko.unwrap(v.element));
        }

        getByKey2(key: TKey, type?: "value", peek?: boolean): [boolean, TElement] {
            var [exists, entry] = this.getEntry(key)

            if (exists) {
                return [true, peek ? entry.item.peek() : entry.item()];
            }
            else {
                if (!peek) this.collObs();
                return [false, null];
            }
        }

        getReadonly(): IReadonlyDictionary<TKey, TElement> {
            return {
                getAll: () => this.getAll2("values"),
                getKeys: () => this.getAll2("keys"),
                getPairs: () => this.getAll2("pairs"),
                tryGet: k => this.getByKey2(k, "value"),
                get: k => this.getByKey2(k, "value")[1],


                peek: k => this.getByKey2(k, "value", true)[1],
                peekAll: () => this.getAll2("values", true),
                peekKeys: () => this.getAll2("keys", true),
                peekPairs: () => this.getAll2("pairs", true),
            }
        }

        getCopy(): DictionaryCollection<TKey, TElement, TOptions> {
            var coll2 = new DictionaryCollection<TKey, TElement, TOptions>(this.options);
            coll2.collObs(this.collObs().map(i => ({ key: i.key, keyString: i.keyString, element: ko.observable(i.element()) })));

            return coll2;
        }

        onChanged(func: () => void): IDisposable {
            if (typeof func == "function")
                return this.collObs.subscribe(() => func());
        }

    }

    export class ViewModelDictionaryCollection<TKey, TModel, TViewModel> extends DictionaryCollection<TKey, TViewModel, ViewModelDictionaryCollectionOptions<TKey, TModel, TViewModel>>{

        constructor(protected options: ViewModelDictionaryCollectionOptions<TKey, TModel, TViewModel>) {
            super(options);
        }

        protected getKey(model: TModel): TKey | false {
            if (model && this.options && this.options.getKey)
                return this.options.getKey(model);

            return false;
        }

        protected createViewModel(model: TModel): TViewModel {
            if (model && this.options && this.options.createViewModel)
                return this.options.createViewModel(model);

            throw new Error("Can't create ViewModels");
        }

        protected updateViewModel(vm: TViewModel, model: TModel) {
            if (model && this.options && this.options.updateViewModel)
                return this.options.updateViewModel(vm, model);

            throw new Error("Can't update ViewModels");
        }

        addModel(model: TModel, overwrite?: boolean) {
            var key = this.getKey(model);
            if (key !== false) {
                var [exists, entry, ks] = this.getEntry(key);

                if (exists) {
                    if (overwrite) {
                        var handled = false;

                        if (this.options.updateViewModel) {
                            var vm = entry.item();
                            if (vm) {
                                this.options.updateViewModel(vm, model);
                                handled = true;
                            }

                        }

                        if (!handled) {
                            entry.item(this.createViewModel(model));
                        }
                    }
                    else
                        throw new Error("Duplicate Key");
                }
                else if (ks) {
                    var vm = this.createViewModel(model);

                    this.collObs.push({ key: key, keyString: ks, element: ko.observable(vm) });
                }
                else
                    throw new Error("Key can't be empty");
            }
            else
                throw new Error("Key is required");
        }

        addModels(...models: TModel[]) {
            let dict = this.itemsDict.peek();
            let pushItems: DictArrPrepItem<TKey, TModel>[] = [];

            for (var i = 0; i < models.length; i++) {
                var model = models[i];
                var key = this.getKey(model);
                if (key !== false) {
                    var [exists, entry, ks] = this.getEntry(key, dict);

                    if (exists) throw new Error("Duplicate Key");
                    if (!ks) throw new Error("Key can't be empty");

                    pushItems.push({ key, keyString: ks, element: model });
                }
                else
                    throw new Error("Key is required");
            }

            if (pushItems.length)
                this.collObs.push(...(pushItems.map(v => ({ key: v.key, keyString: v.keyString, element: ko.observable(this.createViewModel(v.element)) }))));
        }

        reloadModels(...models: TModel[]) {
            var self = this;
            //var curVms = pairsToObject(this.getAll2("pairs", true), this.keyFunc.bind(this));

            var curEntrieDict = this.itemsDict.peek();
            var curEntries = this.collObs.peek();

            var items: DictArrItem<TKey, TViewModel>[] = [];
            if (models)
                models.forEach(m => {
                    var key = self.getKey(m);
                    if (key) {
                        var sKey = this.keyFunc(key);
                        var vm: TViewModel;

                        if (curEntrieDict[sKey]) {
                            let entry = curEntries[curEntrieDict[sKey].ix];
                            items.push(entry);
                            vm = entry.element.peek();

                            if (vm) self.updateViewModel(vm, m);
                            else vm = self.createViewModel(m);
                        }
                        else {
                            var vm = self.createViewModel(m);

                            items.push({ key: key, keyString: sKey, element: ko.observable(vm) });
                        }
                    }
                })

            self.collObs(items);

        }

        getModels(): TModel[] {
            return this.getAll2("values", true).map(this.getModel);
        }
        protected getModel(vm: TViewModel): TModel {
            if (vm && this.options && this.options.getModel)
                return this.options.getModel(vm);

            return null;
        }

    }

    export abstract class DictionaryBase<TKey, TElement> implements IDictionary<TKey, TElement>{

        readonly add: (key: TKey, element: TElement, overwrite?: boolean) => void;
        readonly remove: (key: TKey) => void;
        readonly getAll: { (): TElement[]; };
        readonly getPairs: { (): KeyValuePair<TKey, TElement>[]; };
        readonly getKeys: () => TKey[];
        readonly tryGet: (key: TKey) => [boolean, TElement];
        readonly get: (k: TKey) => TElement;
        readonly clear: () => void;

        readonly peek: (k: TKey) => TElement;
        readonly peekAll: { (): TElement[]; };
        readonly peekPairs: { (): KeyValuePair<TKey, TElement>[]; };
        readonly peekKeys: () => TKey[];
        readonly toReadonly: () => IReadonlyDictionary<TKey, TElement>;

        constructor(options: DictionaryCollectionOptions<TKey, TElement>) {

            var dictColl = new DictionaryCollection<TKey, TElement>(options);

            this.add = dictColl.add.bind(dictColl);
            this.remove = dictColl.remove.bind(dictColl);
            this.clear = dictColl.clear.bind(dictColl);

            var roDict = dictColl.getReadonly();
            utils.extend2(this, roDict);
            this.toReadonly = () => roDict;
        }

    }

    export abstract class KeyedCollectionBase<TKey, TElement> implements IKeyedCollection<TKey, TElement>{

        readonly add: (element: TElement, overwrite?: boolean) => void;
        readonly remove: (key: TKey) => void;
        readonly clear: () => void;
        readonly toReadonly: () => IReadonlyDictionary<TKey, TElement>;

        readonly getAll: { (): TElement[]; };
        readonly getKeys: () => TKey[];
        readonly getPairs: () => KeyValuePair<TKey, TElement>[];

        readonly tryGet: { (key: TKey): [boolean, TElement]; };
        readonly get: (k: TKey) => TElement;

        readonly peek: (k: TKey) => TElement;
        readonly peekAll: { (): TElement[]; };
        readonly peekPairs: { (): KeyValuePair<TKey, TElement>[]; };
        readonly peekKeys: () => TKey[];


        public abstract getKey(element: TElement): TKey;

        constructor(options: DictionaryCollectionOptions<TKey, TElement>) {

            var dictColl = new DictionaryCollection<TKey, TElement>(options);

            this.add = (e, o) => dictColl.add(this.getKey(e), e, o);
            this.remove = dictColl.remove.bind(dictColl);
            this.clear = dictColl.clear.bind(dictColl);

            var roDict = dictColl.getReadonly();
            utils.extend2(this, roDict);
            this.toReadonly = () => roDict;
        }

    }

    export class SimpleDictionary<TKey, TElement> extends DictionaryBase<TKey, TElement>{
        constructor(protected readonly convertKey: { (key: TKey): string }) {
            super({ convertKey });
        }
    }

    export class SimpleStringDictionary<TElement> extends DictionaryBase<string, TElement>{
        constructor() {
            super({});
        }

        convertKey(s: string) { return s; }

        getAsObject(peek?: boolean) {
            return pairsToObject(peek ? this.peekPairs() : this.getPairs());
        }
    }

    export class SimpleKeyedCollection<TKey, TElement> extends KeyedCollectionBase<TKey, TElement>{
        constructor(public readonly getKey: { (e: TElement): TKey }, convertKey: { (key: TKey): string }) {
            super({ convertKey });
        }
    }

    export class SimpleStringKeyedCollection<TElement> extends KeyedCollectionBase<string, TElement>{
        constructor(public readonly getKey: { (e: TElement): string }) {
            super({});
        }


        convertKey(s: string) { return s; }
    }

    // #endregion

    // #region  Ajax
    const aftValError = "AntiForgeryValidationError";

    export function isActionResponse(object: unknown): object is ActionResponse<any> {
        if (typeof object !== "object" || object == null) return false

        var raw = <ActionResponse<any>>object;

        if (typeof raw.status === "string" || typeof raw.status === "number")
            return true;

        return false;

    }

    export function unwrapActionResponse<T>(resData: T | ActionResponse<T>) {
        return isActionResponse(resData) ? resData.data : resData;
    }

    export type ModelStateErrorFormattingGroup = {
        errors: Array<KeyValuePair<string, ModelStateError[]>>,

        name?: string,
        prefix?: string,
        maxSeverity?: ModelStateErrorSeverity
    }

    export type ModelStateErrorFormattingOptions<TGroup extends ModelStateErrorFormattingGroup = ModelStateErrorFormattingGroup> = {
        includeKey?: boolean

        groupingFunc?(errors?: Array<KeyValuePair<string, ModelStateError[]>>): TGroup[];
        groupHeaderFunc?(group: TGroup): string;

        keyFormatter?(key: KeyValuePair<string, ModelStateError[]>, group?: TGroup): string;
        errorFormatter?(error: ModelStateError, key: string, group?: TGroup): string;

    }


    function getHigherSeverity(x: ModelStateErrorSeverity, y: ModelStateErrorSeverity) {
        return Math.min(x, y);
    }
    function getMaxSeverityBase<T>(src: T[], acc: (val: T) => ModelStateErrorSeverity) {
        return src.reduce((n, sg) => getHigherSeverity(acc(sg), n), ModelStateErrorSeverity.info)
    }

    export function getMaxSeverity(errors: ModelStateError | KeyValuePair<string, ModelStateError[]> | ModelStateErrorFormattingGroup | ModelStateError[] | ModelStateErrorFormattingGroup[] | KeyValuePair<string, ModelStateError[]>[]): ModelStateErrorSeverity {
        var res = ModelStateErrorSeverity.info;

        if (errors) {

            if ($.isArray(errors)) {
                res = getMaxSeverityBase(errors, getMaxSeverity);
            }
            else {
                if (typeof (errors as any).maxSeverity == "number") res = (errors as any).maxSeverity;
                else if ((errors as ModelStateErrorFormattingGroup).errors) {
                    let e = (errors as ModelStateErrorFormattingGroup);

                    res = getMaxSeverity(e.errors);
                }
                else if ((errors as KeyValuePair<any, any>).value) {
                    let e = (errors as KeyValuePair<any, any>);

                    res = getMaxSeverity(e.value);
                }
                else if (typeof ((errors as ModelStateError).severity) == "number")
                    res = (errors as ModelStateError).severity;
                else {
                    //console.warn("getMaxSeverity: ", errors);
                    res = ModelStateErrorSeverity.error;
                }
            }
        }
        return res;

    }

    export function formatErrors<TGroup extends ModelStateErrorFormattingGroup = ModelStateErrorFormattingGroup>(errors?: Array<KeyValuePair<string, ModelStateError[]>>, options?: ModelStateErrorFormattingOptions<TGroup>) {
        var msg = "";
        if (errors) {
            let lines: string[] = [];
            if (!options) options = {};

            var incKey = options.includeKey !== false;
            var keyFormatter = options.keyFormatter || ((v, g) => "[" + v.key + "]:");
            var errFormatter = options.errorFormatter || ((e/*, k, g*/) => {
                var msg = e.error;
                // Q> Prepend Severity?
                //msg = e.severity + ": " + msg;

                // indent Messages if the key is Displayed
                if (incKey) msg = "\t" + msg;
                return msg;
            });

            if (options.groupingFunc) {
                var groups = options.groupingFunc(errors);
                $.each(groups, (_, gr) => {
                    if (options.groupHeaderFunc)
                        lines.push(options.groupHeaderFunc(gr));


                    addErrors(gr.errors, gr);
                });
            }
            else
                addErrors(errors, null);

            msg = lines.join("\n");

            function addErrors(errors?: Array<KeyValuePair<string, ModelStateError[]>>, group?: TGroup) {
                $.each(errors, (i, v) => {
                    if (incKey) {
                        lines.push(keyFormatter(v, group));
                    }

                    if (v.value)
                        $.each(v.value, (i, e) => {
                            if (e.error) {
                                lines.push(errFormatter(e, v.key, group));
                            }
                        });
                });
            }
        }

        return msg;

    }

    // Q> Change Method to Return an Object with Properties that describe the Error?
    export function getErrorMsg(jqXhr: JQuery.jqXHR, textStatus: JQuery.Ajax.ErrorTextStatus, errorThrown: string, options?: ModelStateErrorFormattingOptions<any>): string {

        if (typeof jqXhr.responseJSON === "object" && jqXhr.responseJSON != null) {
            if (isActionResponse(jqXhr.responseJSON)) {
                let msMsg = jqXhr.responseJSON;

                var msg = textStatus + ": " + String(msMsg.status);

                if ((msMsg as any).message)
                    msg += "\n" + (msMsg as any).message;

                if (msMsg.messages) {
                    var msg2 = formatErrors(msMsg.messages, options);
                    if (msg2)
                        msg += "\n" + msg2;
                }

                return msg;
            }

        }


        return textStatus + ": " + String(errorThrown);
    }
    export function getError(jqXhr: JQuery.jqXHR, textStatus: JQuery.Ajax.ErrorTextStatus, errorThrown: string, formatting?: ModelStateErrorFormattingOptions): Error {
        var msg = getErrorMsg(jqXhr, textStatus, errorThrown, formatting || simpleErrorHandler.formatting);

        var status: string | number;
        var msgArr: KeyValuePair<string, ModelStateError[]>[];


        if (utils.isActionResponse(jqXhr.responseJSON)) {
            status = (jqXhr.responseJSON as ActionResponse<unknown>).status;
            msgArr = (jqXhr.responseJSON as ActionResponse<unknown>).messages;
        }

        if (textStatus == "error" && jqXhr.status == 403)
            return new viewModels.ForbiddenError(msg);
        else if (typeof status == "string" && equalsIgnoreCase(status, aftValError)) {
            let afErr = new Error(msg);
            afErr.name = aftValError;
            return afErr;
        }
        else
            return new viewModels.DataError(msg, status, msgArr);
    }

    export function isAntiforgeryTokenError(jqXhr: JQuery.jqXHR): boolean {
        if (typeof jqXhr.responseJSON === "object" && jqXhr.responseJSON != null && isActionResponse(jqXhr.responseJSON)) {
            var resp = jqXhr.responseJSON;

            return equalsIgnoreCase(resp.status, aftValError);
        }

        return false;
    }

    export function showAntiforgeryTokenError(error?: string) {
        // TODO Localize error
        //var title = "AntiForgery-Error";
        var msg = cdh.t("view/error/antiForgeryTokenValidation");

        // Q> Handle LineBreaks?

        //if (error)
        //    msg += "<br/><br/>" + error.replace("\n", "<br/>");

        msg += "<br/><br/>" + cdh.t("view/error/reloadSite");


        return ui.alertIcon(msg, "error");
    }

    // TODO Type of Errors
    export const simpleErrorHandler: { formatting: ModelStateErrorFormattingOptions } & ISendAjaxErrorHandler = {
        formatting: {
            includeKey: false,
            errorFormatter: e => e.error
        },

        onError: (jqXhr, textStatus, errorThrown) => {
            let err = getError(jqXhr, textStatus, errorThrown, simpleErrorHandler.formatting);

            DevExpress.ui.notify(err.message, "error", 1200);

            if (equalsIgnoreCase(err.name, aftValError))
                showAntiforgeryTokenError(err.message);


            throw err;
        }, onMessages: (res) => {
            if (!res || !res.messages || !res.messages.length)
                return;

            var maxSev: ModelStateErrorSeverity = getMaxSeverity(res.messages);

            var msg = formatErrors(res.messages, simpleErrorHandler.formatting);

            msg = msg.replace(/\n/g, "<br/>").replace(/\t/g, "&nbsp;&nbsp;&nbsp;&nbsp;");
            if (maxSev == ModelStateErrorSeverity.info) {
                DevExpress.ui.notify(msg, "info", 1200);
            }
            else {
                var ico: ui.alertIcons = "error";
                switch (maxSev) {
                    //case ModelStateErrorSeverity.info:
                    //    ico = "info";
                    //    break;
                    case ModelStateErrorSeverity.warning:
                        ico = "warning";
                        break;
                }

                return ui.alertIcon(msg, ico);
            }
        }
    }

    export const promptErrorHandler: ISendAjaxErrorHandler = {
        onError: (jqXhr, textStatus, errorThrown) => {
            let err = getError(jqXhr, textStatus, errorThrown, simpleErrorHandler.formatting);

            if (equalsIgnoreCase(err.name, aftValError))
                showAntiforgeryTokenError(err.message);
            else
                ui.alertIcon(err.message, "error");

            throw err;
        },
        onMessages: (res) => {
            if (!res || !res.messages || !res.messages.length)
                return;

            var maxSev: ModelStateErrorSeverity = getMaxSeverity(res.messages);

            var msg = formatErrors(res.messages, simpleErrorHandler.formatting);

            var ico: ui.alertIcons = "error";
            switch (maxSev) {
                case ModelStateErrorSeverity.info:
                    ico = "info";
                    break;
                case ModelStateErrorSeverity.warning:
                    ico = "warning";
                    break;
            }

            msg = msg.replace(/\n/g, "<br/>").replace(/\t/g, "&nbsp;&nbsp;&nbsp;&nbsp;")
            return ui.alertIcon(msg, ico);

        }
    }

    type ErrorListAdd = {
        readonly status: KnockoutReadonlyObservable<any>;
        readonly handler: ISendAjaxErrorHandler;
    }
    export function getErrorList(promptOnError: boolean): KnockoutReadonlyObservable<IMessage> & ErrorListAdd {
        var errors: KnockoutObservable<IMessage> & Partial<Mutable<ErrorListAdd>> = ko.observable<IMessage>(null);

        errors.status = ko.observable();
        errors.handler = getErrorListHandler(errors, promptOnError);

        return <KnockoutReadonlyObservable<IMessage> & ErrorListAdd>errors;
    }

    export function getErrorListHandler(errors: KnockoutObservable<{ messages?: Array<KeyValuePair<string, ModelStateError[]>> }>, promptOnError: boolean): ISendAjaxErrorHandler {
        if (!ko.isWriteableObservable(errors)) throw new Error("errors needs to be an writable Observable");

        let elAdd = errors as Partial<ErrorListAdd>;
        var st: KnockoutObservable<any> = null;
        if ("status" in elAdd && ko.isWriteableObservable(elAdd.status))
            st = elAdd.status;


        return {
            clear: () => {
                errors(null);
                if (st) st(null);
            },
            onMessages: setMessages,
            onError: (jqXhr, textStatus, errorThrown) => {
                if (isActionResponse(jqXhr.responseJSON)) {
                    setMessages(jqXhr.responseJSON);
                }
                let err = getError(jqXhr, textStatus, errorThrown);

                if (equalsIgnoreCase(err.name, aftValError))
                    showAntiforgeryTokenError(err.message);
                else if (promptOnError) {
                    DevExpress.ui.notify(err.message, "error", 1200);
                }

                throw err;
            }
        };

        function setMessages(res: ActionResponse<any>) {
            if (res.messages && res.messages.length)
                errors({ messages: res.messages });
            if (st)
                st(res.status);
        }
    }

    export function sendAjaxBase<TData = any, TResult = TData>(options: ISendAjaxOptions<TData>): JQuery.jqXHR<TResult | ActionResponse<TResult>> {
        if (!options.method)
            options.method = options.data ? "POST" : "GET";

        let settings: JQueryAjaxSettings = {
            "method": options.method,
            url: options.url,
            dataType: "json"
        }

        if (options.data != null) {
            settings.data = JSON.stringify(options.data);
            settings.contentType = "application/json";
        }

        return $.ajax(settings);
    }

    export function sendAjax<TData = any, TResult = TData>(options: ISendAjaxOptions<TData>): JQuery.Promise<TResult> {

        let jqXhr = sendAjaxBase<TData, TResult>(options);

        return handleAjaxErrors(jqXhr, options.errors);
    }

    export function handleAjaxErrors<T>(req: JQuery.jqXHR<T | ActionResponse<T>>, handler: ISendAjaxErrorHandler): JQuery.Promise<T> {

        if (ko.isWriteableObservable(handler)) {
            handler = getErrorListHandler(handler, true);
        }

        if (typeof handler === "object" && handler != null) {
            if (handler.clear) handler.clear();
        }
        else
            handler = simpleErrorHandler;

        return req.then(d => {
            if (isActionResponse(d)) {

                if (handler.onMessages && d.messages && d.messages.length)
                    handler.onMessages(d);


                return d.data;
            }
            return d;
        }, handler.onError);
    }


    function handleRequest<TOut, TIn = any>(req: JQuery.jqXHR<TIn>, func: (d: TIn) => TOut, ignoreNotFound: boolean): JQuery.Promise<TOut> {

        let func2 = func ? (res: TIn) => func(unwrapActionResponse(res)) : unwrapActionResponse;

        return req.then(
            func2,
            (jqXhr, textStatus, errorThrown) => {
                if (ignoreNotFound && jqXhr.status == 404) return null;
                else throw new Error(getErrorMsg(jqXhr, textStatus, errorThrown));
            });
    }


    export function getText(url: string): JQuery.Promise<string> {
        let p = $.get(url);

        return handleRequest(p, null, false);
    }

    export function getSingle<T>(url: string): JQuery.Promise<T>;
    export function getSingle<T>(url: string, type: IViewModelConstructor<T>, parent: MappableBlock): JQuery.Promise<T>;
    export function getSingle<T>(url: string, type?: IViewModelConstructor<T>, parent?: MappableBlock): JQuery.Promise<T> {
        return handleRequest($.getJSON(url), type ? d => new type(parent, d) : null, false);
    }

    export function getSingleOrDefault<T>(url: string): JQuery.Promise<T> {
        return handleRequest($.getJSON(url), null, true);
    }

    export function getList<T>(url: string): JQuery.Promise<T[]>;
    export function getList<T>(url: string, type: IViewModelConstructor<T>, parent: MappableBlock): JQuery.Promise<T[]>;
    export function getList<T>(url: string, type?: IViewModelConstructor<T>, parent?: MappableBlock): JQuery.Promise<T[]> {

        let p = $.getJSON(url);

        var func = type ? (data: MappableObject[]) => asVmList(data, type, parent) : null;

        return handleRequest(p, func, false);
    }

    export function getSearch<T>(url: string): JQuery.Promise<SearchResult<T>>;
    export function getSearch<T>(url: string, type: IViewModelConstructor<T>, parent: MappableBlock): JQuery.Promise<SearchResult<T>>;
    export function getSearch<T>(url: string, type?: IViewModelConstructor<T>, parent?: MappableBlock): JQuery.Promise<SearchResult<T>> {

        let p = $.getJSON(url);

        var func = type ? (data: SearchResult<MappableObject>) => ({
            data: asVmList(data.data, type, parent),
            summary: data.summary,
            totalCount: data.totalCount
        }) : null;

        return handleRequest(p, func, false);
    }

    export function asVmList<TM, TVm, TParent = any>(data: TM[], type: { new(parent: TParent, model?: TM): TVm }, parent: TParent) {
        var items: TVm[] = []

        data.forEach(obj => {
            items.push(new type(parent, obj));
        });

        return items;
    }

    export async function appendScriptsBase(container: Element, ...urls: string[]): Promise<void> {

        for (var i = 0; i < urls.length; i++) {
            await appendScriptBase(container, urls[i]);
        }
    }

    function appendScriptBase(container: Element, url: string): Promise<void> {

        if (!url) return Promise.resolve();

        let elm = document.createElement("script");
        let p = $.Deferred();

        elm.onload = e => {
            p.resolve();
            elm.onload = null;
            elm.onerror = null;
        };
        elm.onerror = e => {
            p.reject(new Error("Script '" + url + "' not found"));
            elm.onload = null;
            elm.onerror = null;
        }
        elm.src = url;

        container.append(elm);

        return p.promise();
    }

    export class DataCache {
        _requests: { [key: string]: JQuery.jqXHR } = {};

        public get(url: string) {
            if (this._requests[url] === undefined) {
                return this._requests[url] = $.getJSON(url);
            }
            else
                return this._requests[url];
        }


        public getSingle<T>(url: string): JQuery.Promise<T>;
        public getSingle<T>(url: string, type: IViewModelConstructor<T>, parent: MappableBlock): JQuery.Promise<T>;
        public getSingle<T>(url: string, type?: IViewModelConstructor<T>, parent?: MappableBlock): JQuery.Promise<T> {
            let p = this.get(url);

            return handleRequest(p, type ? d => new type(parent, d) : null, false);
        }

        public getList<T>(url: string): JQuery.Promise<T[]>;
        public getList<T>(url: string, type: IViewModelConstructor<T>, parent: MappableBlock): JQuery.Promise<T[]>;
        public getList<T>(url: string, type?: IViewModelConstructor<T>, parent?: MappableBlock): JQuery.Promise<T[]> {
            let p = this.get(url);

            var func = type ? (data: MappableObject[]) => asVmList(data, type, parent) : null;

            return handleRequest(p, func, false);

        }

        public clearCache() {
            this._requests = {};
        }

        public removeEntry(url: string) {
            delete this._requests[url];
        }
    }

    export abstract class RepositoryBase {

        constructor(private _cache: DataCache) { }

        protected getSingle<T>(url: string, overwriteCache?: boolean): JQuery.Promise<T>;
        protected getSingle<T>(url: string, overwriteCache: boolean, type: IViewModelConstructor<T>, parent: MappableBlock): JQuery.Promise<T>;
        protected getSingle<T>(url: string, overwriteCache?: boolean, type?: IViewModelConstructor<T>, parent?: MappableBlock): JQuery.Promise<T> {

            if (this._cache) {
                if (overwriteCache) this._cache.removeEntry(url);
                return this._cache.getSingle(url, type, parent);
            }
            else
                return utils.getSingle(url, type, parent);
        }

        protected getList<T>(url: string, overwriteCache?: boolean): JQuery.Promise<T[]>;
        protected getList<T>(url: string, overwriteCache: boolean, type: IViewModelConstructor<T>, parent: MappableBlock): JQuery.Promise<T[]>;
        protected getList<T>(url: string, overwriteCache?: boolean, type?: IViewModelConstructor<T>, parent?: MappableBlock): JQuery.Promise<T[]> {

            if (this._cache) {
                if (overwriteCache) this._cache.removeEntry(url);
                return this._cache.getList(url, type, parent);
            }
            else
                return utils.getList(url, type, parent);
        }

    }


    export function normalizeUrl(url: string, excludeApi?: boolean): [boolean, string?];
    export function normalizeUrl(url: string, excludeApi: boolean, splitParts: true): [boolean, string?, string?, string?]
    export function normalizeUrl(url: string, excludeApi = false, splitParts = false): [boolean, string?, string?, string?] {
        if (utils.startsWithIgnoreCase(url, location.origin))
            url = url.substr(location.origin.length);

        // Q> Enhance support for Relative Links?

        if (utils.startsWithIgnoreCase(url, Router.baseUrl) && !(excludeApi && utils.startsWithIgnoreCase(url, Router.baseUrl + "api/"))) {
            url = url.substr(Router.baseUrl.length)
            if (splitParts) {
                let q: string = null;
                let f: string = null;

                let p = url.split("#", 2);
                url = p[0];
                f = p[1];
                p = url.split("?", 2);
                url = p[0];
                q = p[1];

                return [true, url, q, f];
            }



            return [true, url];
        }

        return [false];
    }

    export interface ModuleDefinition {
        isLoaded?: boolean;
        readonly name: string;
        readonly dependencies?: string[];

        // Paths relative to the baseUrl
        readonly scriptsBundle?: string;
        readonly scripts?: string[];
        readonly styles?: string[];

    }

    class ModuleLoader {
        private readonly _modules = new SimpleStringKeyedCollection<ModuleDefinition>(m => m.name);
        private readonly _scripts: Dictionary<true> = {};
        private readonly _styles: Dictionary<true> = {};
        private _scriptsAppendElm: Element;
        private _stylesAppendElm: Element;

        constructor() {
            $(() => {
                this.init();
            })
        }

        loadBundles = false;

        private init() {
            this._scriptsAppendElm = document.body;
            this._stylesAppendElm = document.head;
            let self = this;

            $("script[src]").each(function (this: HTMLScriptElement) {
                let [res, url] = normalizeUrl(this.src, true, true);
                if (res) self._scripts[url.toLowerCase()] = true;
            });


        }

        private getLoadOrder(names: string[]): ModuleDefinition[] {
            let self = this;
            // TODO Check if dependencies are put in the right order?
            let modulesLoading: ModuleDefinition[] = [];
            let modulesResolved: ModuleDefinition[] = [];
            let namesResolved: Dictionary<true> = {};
            let namesLoading: Dictionary<true> = {};

            let n = 100;
            while (names.length || modulesResolved.length) {
                if (--n <= 0) throw new Error("Dependency Tree to Complex || Cyclic Dependency");

                // Resolve Names if necessary
                while (names.length) resolveModule(names.shift());

                for (var i = 0; i < modulesResolved.length; i++) {
                    let mod = modulesResolved[i];
                    let canAdd = true;

                    // Check if all dependencies are added?
                    if (mod.dependencies)
                        mod.dependencies.forEach(dep => {
                            if (dep) {
                                dep = dep.toLowerCase();
                                if (!namesLoading[dep]) {
                                    canAdd = false;
                                    names.push(dep);
                                }
                            }
                        });

                    if (canAdd) {
                        modulesLoading.push(mod);
                        modulesResolved.splice(i, 1);
                        namesLoading[mod.name.toLowerCase()] = true;
                        i--;
                    }

                }

            }

            //console.log("Calculated LoadOrder", { n, modules: modulesLoading.map(m => m.name) });

            return modulesLoading;

            function resolveModule(name: string) {
                if (!name) return;
                name = name.toLowerCase();
                if (namesResolved[name]) return;
                namesResolved[name] = true;

                let [res, mod] = self._modules.tryGet(name);
                if (res) {
                    if (!mod.isLoaded)
                        modulesResolved.push(mod);
                    else
                        namesLoading[name] = true;
                }
                else {
                    console.warn("can't find module", name);
                }
            }
        }

        public async load(...names: string[]) {

            // Find the definition of the requested Module and its dependencies
            let modules = this.getLoadOrder(names);

            while (modules.length)
                await this.loadModule(modules.shift());
        }

        private async loadModule(mod: ModuleDefinition) {
            // TODO Optimize loading Logic
            // TODO Load Styles

            if (mod.isLoaded) return;

            let sc: string[] = null;

            if (mod.scriptsBundle) {
                let s = mod.scriptsBundle.toLowerCase();
                if (this._scripts[s]) return;
            }

            if (mod.scripts) {
                let any = false;
                sc = mod.scripts.filter(s => {
                    if (!s) return false;
                    s = s.toLowerCase();

                    if (this._scripts[s]) {
                        any = true;
                        return false;
                    }

                    return true;
                });

                if (this.loadBundles && !any && mod.scriptsBundle)
                    sc = [mod.scriptsBundle];

            }

            if (sc && sc.length) {
                while (sc.length) {
                    var s = sc.shift();
                    await appendScriptBase(this._scriptsAppendElm, Router.baseUrl + s);
                    this._scripts[s.toLowerCase()] = true;
                }
            }

            mod.isLoaded = true;
        }

        public addModule(mod: ModuleDefinition) {
            return this._modules.add(mod);
        }

        hasModule(name: string): boolean {
            return this._modules.tryGet(name)[0];
        }

        isLoaded(name: string): boolean {
            var mod = this._modules.get(name);

            if (mod) return mod.isLoaded;
            else return null;
        }

    }

    export const moduleLoader = new ModuleLoader();

    // #endregion


    function getOptions<T>(storage: Storage, name: string): T {
        var tmp: T = null;

        let entriesString = storage.getItem(name);

        if (entriesString) tmp = JSON.parse(entriesString);

        return tmp;
    }
    function setOptions<T>(storage: Storage, name: string, val: T): void {

        let entriesString: string = null;

        if (val) entriesString = JSON.stringify(val);

        if (entriesString)
            storage.setItem(name, entriesString);
        else
            storage.removeItem(name);

    }

    function addStorageEvent(storage: Storage, name: string, action: Function): IDisposable {
        if (storage != null && name) {
            var g = storageListeners.find(g => g.storage == storage);
            if (!g)
                storageListeners.push(g = { storage: storage, listeners: [] });

            var l: storageListenerReg = {
                key: name, action: action, dispose: () => {
                    if (l && g) {
                        var ix = g.listeners.indexOf(l);
                        if (ix! - 1)
                            g.listeners.splice(ix, 1);

                        l = null;
                        g = null;
                    }
                }
            };
            g.listeners.push(l);

            return l;

        }

        return null;
    }

    window.addEventListener("storage", ev => {
        storageListeners.forEach(group => {
            if (group.storage == ev.storageArea) {
                group.listeners.forEach(listener => {
                    var execute = false;
                    var key = listener.key;
                    if (typeof key == "string")
                        execute = utils.equalsIgnoreCase(key, ev.key);
                    else if (typeof key == "function")
                        execute = key(ev.key);

                    if (execute)
                        listener.action()

                });

            }
        });
    });

    export function getLocalOptions<T>(name: string): T {
        var tmp: T = null;

        // Q> Fallback to Cookies?
        if (localStorage && name) {
            tmp = getOptions(localStorage, name);
        }

        return tmp;
    }
    export function setLocalOptions<T>(name: string, val: T): void {

        // Q> Fallback to Cookies?
        if (localStorage && name) {
            setOptions(localStorage, name, val);
        }
    }
    export function addLocalOptionsListener(name: string, action: Function) {
        if (localStorage && name) {
            addStorageEvent(localStorage, name, action);
        }
    }

    export function getSessionOptions<T>(name: string): T {
        var tmp: T = null;
        // Q> Fallback to Cookies?
        if (sessionStorage && name) {
            tmp = getOptions(sessionStorage, name);
        }
        return tmp;
    }
    export function setSessionOptions<T>(name: string, val: T): void {
        // Q> Fallback to Cookies?
        if (sessionStorage && name) {
            setOptions(sessionStorage, name, val);
        }
    }
    export function addSessionOptionsListener(name: string, action: Function) {
        if (sessionStorage && name) {
            addStorageEvent(sessionStorage, name, action);
        }
    }

    export interface IRecentTermsProvider {

        getTerms(name: string): string[];
        addRecentTerm(name: string, term: string, max?: number): void;
        truncateTerms(name: string, max?: number): void;

        getGroup(name: string): IRecentTermsGroup
    }

    export interface IRecentTermsGroup {

        maxSize: number;

        terms: KnockoutReadonlyComputed<string[]>;
        termModels: KnockoutReadonlyComputed<TermModel[]>;
        groupedTerms: KnockoutReadonlyComputed<GroupedTerms[]>;

        addTerm(term: string): void;
        removeTerm(term: string): void;
    }

    export abstract class RecentTermsBase implements IRecentTermsProvider {
        static readonly maxEntries = 20;
        static readonly defaultName = "genericTerms";

        private allTerms = ko.observable<{ [name: string]: [string, string][] }>();

        private getAllTerms() {
            let _allTerms = ko.unwrap(this.allTerms);
            if (!_allTerms) {
                _allTerms = {};

                this.allTerms(_allTerms);
            }

            return _allTerms;
        }

        constructor() {
        }
        // Q> Create an Interface for the Storage Functions (Generic) and use it as a dependency instead.
        protected abstract loadTermsCore(): { [name: string]: [string, string][] };
        protected abstract saveTermsCore(terms: { [name: string]: [string, string][] }): void;

        public loadTerms() {
            this.allTerms(this.loadTermsCore() || {});
        }

        public saveTerms() {
            this.saveTermsCore(this.getAllTerms());
        }

        public getTermsBase(name: string) {

            if (typeof name !== "string" || !name)
                return [];

            let terms = this.getAllTerms()[name];
            if (terms)
                return terms.slice().reverse();
            else
                return [];
        }

        public getTerms(name: string) {
            let terms = this.getTermsBase(name);
            if (terms)
                return terms.map(t => t[0]);
            else
                return [];
        }

        public addRecentTerm(name: string, term: string, max?: number) {
            if (typeof name !== "string" || !name)
                return;

            let _allTerms = this.getAllTerms();
            let terms = _allTerms[name] || [];
            let changed = false;

            if (max === undefined)
                max = RecentTermsBase.maxEntries;

            if (term) {
                terms = terms.filter(t => !utils.equalsIgnoreCase(term, t[0]));
                var d = moment().format("yyyy-MM-DD");
                terms.push([term, d]);
                changed = true;
            }

            if (terms.length > max) {
                terms = terms.slice(terms.length - max);
                changed = true;
            }

            if (changed) {
                _allTerms[name] = terms;
                this.allTerms.notifySubscribers();

                this.saveTerms();
            }
        }

        public removeRecentTerm(name: string, term: string): void {
            if (typeof name !== "string" || !name) return;
            if (typeof term !== "string" || !term) return;

            let _allTerms = this.getAllTerms();
            let terms = _allTerms[name];

            if (!terms) return;

            var cnt = terms.length;
            terms = terms.filter(t => !utils.equalsIgnoreCase(term, t[0]));

            if (terms.length != cnt) {
                _allTerms[name] = terms;
                this.allTerms.notifySubscribers();

                this.saveTerms();
            }
        }

        public truncateTerms(name: string, max?: number) {
            if (typeof name !== "string" || !name)
                return;

            let _allTerms = this.getAllTerms();
            let terms = _allTerms[name] || [];
            let changed = false;

            if (max === undefined)
                max = RecentTermsBase.maxEntries;

            if (terms.length > max) {
                terms = terms.slice(terms.length - max);
                changed = true;
            }

            if (changed) {
                _allTerms[name] = terms;
                this.allTerms.notifySubscribers();

                this.saveTerms();
            }
        }

        public getGroup(name: string): RecentTermGroup {
            return new RecentTermGroup(this, name);
        }
    }

    export interface TermModel {
        readonly index: number;
        readonly value: string;
        readonly date: moment.Moment | null;
        readonly parent: RecentTermGroup;
        remove(): void;
    }

    export interface GroupedTerms {
        //readonly key: moment.Moment | null;
        readonly key: string;
        readonly items: TermModel[];
    }

    function groupTerms(terms: TermModel[]): GroupedTerms[] {
        var groups: GroupedTerms[] = [];

        var curDate: moment.Moment = null;
        var items: TermModel[] = [];

        if (terms) {
            terms.forEach(t => {
                if (!isCurDate(t.date)) {
                    addGroup();
                    curDate = t.date;
                }
                items.push(t);
            });
            addGroup()
        }

        return groups;

        function addGroup() {
            if (items.length) {
                var key = curDate ? utils.formatting.dateFormatter.formatValue(curDate, "d") : null;

                groups.push({
                    key: key,
                    items: items
                });
                items = [];
            }

        }

        function isCurDate(m: moment.Moment) {
            if (!moment.isMoment(m) || !m.isValid()) {
                return curDate == null;
            }
            else if (curDate == null)
                return false;
            else
                return m.isSame(curDate, "day");
        }

    }

    export class RecentTermGroup implements IRecentTermsGroup {
        _maxSize: number = RecentTermsBase.maxEntries;

        constructor(readonly parent: RecentTermsBase, readonly name: string) {

        }

        get maxSize() {
            return this._maxSize || RecentTermsBase.maxEntries;
        }
        set maxSize(value: number) {
            if (!value) value = RecentTermsBase.maxEntries;

            var curSize = this.maxSize;
            this._maxSize = value;

            if (value < curSize)
                this.parent.truncateTerms(this.name, value);
        }

        terms = ko.pureComputed(() => {
            var trmModArr = ko.unwrap(this.termModels);

            return trmModArr.map(m => m.value);

        }).extend({ deferred: true });

        termModels = ko.pureComputed<TermModel[]>(() => {
            if (!this.parent || !this.name) return [];

            var tArr = this.parent.getTermsBase(this.name);

            return tArr.map((t, i) => ({
                index: i,
                value: t[0],
                date: t[1] ? moment(t[1], "yyyy-MM-DD") : null,
                parent: this,
                remove: () => this.removeTerm(t[0])
            }));
        }).extend({ deferred: true });

        groupedTerms = ko.pureComputed(() => groupTerms(this.termModels()));

        addTerm(term: string) {
            if (term && this.parent && this.name)
                this.parent.addRecentTerm(this.name, term, this.maxSize);
        }

        removeTerm(term: string) {
            if (term && this.parent && this.name)
                this.parent.removeRecentTerm(this.name, term);

        }

    }

    export class StorageRecentTerms extends RecentTermsBase {
        private readonly _storage: Storage
        private readonly _reg: IDisposable;

        constructor(readonly storageKey: string, storageType: "local" | "session") {
            super();

            if (storageType == "session")
                this._storage = sessionStorage;
            else // if (storageType == "local")
                this._storage = localStorage;


            this.loadTerms();
            this._reg = addStorageEvent(this._storage, storageKey, () => this.loadTerms());
        }

        protected loadTermsCore() {
            let tmp: { [name: string]: (string | [string, string])[] };
            let tmp2: { [name: string]: [string, string][] } = {};

            if (this._storage && this.storageKey)
                tmp = getOptions(this._storage, this.storageKey);

            if (tmp)
                $.each(tmp, (pn, pv) => {
                    if (typeof (pn) != "string") return;

                    var trms: [string, string][] = [];
                    pv.forEach(t => {
                        if ($.isArray(t))
                            trms.push(t);
                        else if (typeof (t) == "string")
                            trms.push([t, null]);
                    });

                    if (trms.length)
                        tmp2[pn] = trms;
                });

            return tmp2;
        }

        public saveTermsCore(terms: { [name: string]: [string, string][] }) {

            if (this._storage && this.storageKey)
                setOptions(this._storage, this.storageKey, terms);
        }

        public dispose() {
            this._reg.dispose();
        }

    }

    export class WrapperRecentTerms implements IRecentTermsProvider {
        public readonly provider: KnockoutObservable<IRecentTermsProvider> = ko.observable();

        getTerms(name: string): string[] {
            var prov = ko.unwrap(this.provider);
            return prov ? prov.getTerms(name) : [];
        }
        addRecentTerm(name: string, term: string, max?: number): void {
            var prov = ko.unwrap(this.provider);
            if (prov) prov.addRecentTerm(name, term, max);
        }
        truncateTerms(name: string, max?: number): void {
            var prov = ko.unwrap(this.provider);
            if (prov) prov.truncateTerms(name, max);
        }
        getGroup(name: string): IRecentTermsGroup {
            return new WrapperRecentTermsGroup(this, name);
        }


    }
    class WrapperRecentTermsGroup implements IRecentTermsGroup {
        private readonly _group: KnockoutReadonlyComputed<IRecentTermsGroup>;

        constructor(readonly parent: WrapperRecentTerms, readonly name: string) {
            this._group = ko.computed(() => {
                var prov = this.parent.provider();
                return prov ? prov.getGroup(name) : null;
            });
        }
        get maxSize(): number {
            var g = this._group();

            return g ? g.maxSize : RecentTermsBase.maxEntries;
        }

        set maxSize(newValue: number) {
            var g = this._group();
            if (g) g.maxSize = newValue;
        }
        terms: KnockoutReadonlyComputed<string[]> = ko.pureComputed(() => {
            var g = this._group();
            return g ? g.terms() : [];
        });
        termModels: KnockoutReadonlyComputed<TermModel[]> = ko.pureComputed(() => {
            var g = this._group();
            return g ? g.termModels() : [];
        });
        groupedTerms = ko.pureComputed(() => {
            var g = this._group();
            return g ? g.groupedTerms() : [];
        });
        addTerm(term: string): void {
            var g = this._group();
            if (g) g.addTerm(term);
        }
        removeTerm(term: string): void {
            var g = this._group();
            if (g) g.removeTerm(term);
        }
    }

    // create Object in the initConfig function (cdh.init.ts) and use the prefix for the storage key?
    //export const terms: IRecentTermsProvider = new StorageRecentTerms("cdh.pcpw.searchTerms", "local");
    export const terms = new WrapperRecentTerms();


    export class LocalOptionManager {

        // Q> Define StorageKeyHelper?
        static prefix: string;
        static suffix: string;

        readonly load: () => void;
        readonly save: () => void;
        readonly getOption: <T>(option: string, defVal?: T) => KnockoutComputed<T>;

        constructor(name: string) {
            var dict = new utils.DictionaryCollection<string, any>({});
            let loading = false;

            const key = (LocalOptionManager.prefix || "localOptions:") + name + LocalOptionManager.suffix;

            this.load = function () {
                let tmp = getLocalOptions<Dictionary<any>>(key);

                loading = true;

                dict.clear();
                if (tmp) {
                    dict.addMultiple(...(Object.keys(tmp).map(k => ({ key: k, element: tmp[k] }))));
                }

                loading = false;
            }

            this.save = function () {
                let tmp: Dictionary<any> = {};

                dict.getAll2("pairs", true).forEach(v => tmp[v.key] = v.value);

                setLocalOptions(key, tmp);
            }

            this.getOption = function (option: string, defVal?: any) {
                return ko.pureComputed({
                    read: () => {
                        var res = dict.getByKey2(option);
                        return res[0] ? res[1] : defVal;
                    },
                    write: val => dict.add(option, val, true)
                });
            }

            this.load();

            dict.onChanged(() => {
                if (loading) return;

                this.save();
            });

        }

    }

    export abstract class CommandManagerBase<TArg> implements ICommandManager<TArg> { // Q> Implement ICommandHandler?
        private _cmdMgrParent: ICommandManager<TArg>;

        protected abstract getCommandHandlers(): Iterable<ICommandHandler<TArg>>;
        addData?(ctx: ICommandContext<TArg>): void;

        setParent(cmdMgr: ICommandManager<TArg>) {
            this._cmdMgrParent = cmdMgr;
        }
        getParent(): ICommandManager<TArg> {
            return this._cmdMgrParent || null;
        }

        protected prepareCtx(cmd: string, arg: TArg, element?: HTMLElement, data?: Dictionary<any>): ICommandContext<TArg> {
            var ctx: ICommandContext<TArg> = {
                cmd: cmd,
                arg: arg,
                element: element,
                data: data || {},

                handled: false
            };
            if (this.addData)
                this.addData(ctx);

            return ctx;
        }

        async sendCommand(cmd: string, arg: TArg, element?: HTMLElement, data?: Dictionary<any>) {
            let ctx = this.prepareCtx(cmd, arg, element, data);

            await this.handleCommand(ctx);

            return ctx.handled || false;
        }

        async receiveCommand(ctx: ICommandContext<TArg>) {
            if (!ctx || ctx.handled) return;

            if (this.addData)
                this.addData(ctx);

            await this.handleCommand(ctx);
        }

        async handleCommand(ctx: ICommandContext<TArg>) {
            let itCmd = this.getCommandHandlers()[Symbol.iterator]();

            do {
                let r: IteratorResult<ICommandHandler<TArg>> = itCmd.next();
                if (r.done) break;

                try {
                    await r.value.handleCommand(ctx);
                }
                catch (er) {
                    console.error("Error handling Command", er, ctx, r.value);
                }
                if (ctx.handled) break;

            }
            while (true);

            if (!ctx.handled && this._cmdMgrParent)
                await this._cmdMgrParent.receiveCommand(ctx);
        }

    }

    export class BasicCommandHandler<TKey> implements ICommandHandler<TKey> {
        handleCommand(ctx: ICommandContext<TKey>): Promise<void> {
            ctx.handled = this.handleCmdBase(ctx.cmd, ctx.arg, ctx.element);
            return Promise.resolve();
        }

        constructor(readonly handleCmdBase: (cmd: string, key: TKey, elm: HTMLElement) => boolean) { }


    }

    export class PrefixCommandHandler<TKey> implements ICommandHandler<TKey>{
        private readonly _handlers: Dictionary<ICommandHandler<TKey>> = {};

        async handleCommand(ctx: ICommandContext<TKey>): Promise<void> {
            if (ctx && typeof ctx.cmd == "string") {
                var parts = ctx.cmd.split(".", 2);
                if (parts.length == 2) {
                    var prefix = parts[0].toLowerCase();

                    var handler = this._handlers[prefix];

                    if (handler)
                        var ctx2: Mutable<ICommandContext<any>> = utils.copy(ctx);
                    ctx2.cmd = parts[1];

                    await handler.handleCommand(ctx2);
                    ctx.handled = ctx2.handled;

                }
            }

        }

        addHandler(prefix: string, handler: ICommandHandler<TKey>) {
            if (!prefix || typeof prefix != "string" || prefix.indexOf(".") != -1)
                throw new Error("Invalid Prefix");
            if (handler) {
                this._handlers[prefix] = handler;
            }
            else
                delete this._handlers[prefix];

        }

    }

    export class MultiCommandManager<TKey> extends CommandManagerBase<TKey> {

        private _handler: ICommandHandler<TKey>[] = [];


        constructor(...handlers: ICommandHandler<TKey>[]) {
            super();

            this.addHandlers(...handlers);

        }

        //importHandlers(mgr: MultiCommandManager<TKey>) {
        //    if (mgr != null) {

        //        this.addHandlers(...mgr._handler);
        //    }
        //}

        addHandlers(...handlers: ICommandHandler<TKey>[]) {
            handlers.forEach(h => {
                if (h != null)
                    this._handler.push(h);
            });
        }

        addHandlersStart(...handlers: ICommandHandler<TKey>[]) {
            handlers.forEach(h => {
                if (h != null)
                    this._handler.unshift(h);
            });
        }


        protected getCommandHandlers() {
            return this._handler;
        }

    }

    export class CommandAdapter<TArg> implements ICommandManager<TArg>{

        constructor(readonly mgr: ICommandManager<TArg>) {

        }

        defaultArg?: TArg;
        addData?(ctx: ICommandContext<TArg>): void;
        modifyContext?(ctx: ICommandContext<TArg>): ICommandContext<TArg>;

        async sendCommand(cmd: string, arg: TArg, element: HTMLElement, data?: Dictionary<any>): Promise<boolean> {
            let ctx = this.prepareCtx(cmd, arg, element, data);

            await this.handleCommand(ctx);

            return ctx.handled || false;
        }

        async receiveCommand(ctx: ICommandContext<TArg>): Promise<void> {
            if (!ctx || ctx.handled) return;

            if (this.addData)
                this.addData(ctx);

            await this.handleCommand(ctx);
        }
        handleCommand(ctx: ICommandContext<TArg>): Promise<void> {
            return this.mgr.handleCommand(ctx);
        }

        protected prepareCtx(cmd: string, arg: TArg, element?: HTMLElement, data?: Dictionary<any>): ICommandContext<TArg> {

            // Q> Change cmd/arg?

            if (arg == null) {
                if (this.defaultArg != null)
                    arg = this.defaultArg;
            }

            var ctx: ICommandContext<TArg> = {
                cmd: cmd,
                arg: arg,
                element: element,
                data: data || {},

                handled: false
            };

            if (this.addData)
                this.addData(ctx);

            if (this.modifyContext)
                this.modifyContext(ctx);

            return ctx;
        }

    }

    export class DisplayModeViewModel implements IDisplayMode {

        constructor(private parent: IDisplayMode, private defaultDisplayMode: number | { (): number }, private maxDisplayMode: number, private minDisplayMode: number = 1) {
            var self = this;

            parent.displayMode = this.displayMode;
            parent.displayModeName = this.displayModeName;
            parent.setDisplayMode = (dm) => self.setDisplayMode(dm);
            parent.toggleDisplayMode = () => self.toggleDisplayMode();

            this.setDisplayMode();
        }

        displayMode = ko.observable<number>();
        displayModeName = ko.pureComputed<string>(() => {
            var dm = ko.unwrap(this.displayMode);
            var res: string;

            switch (dm) {
                case 1:
                    res = "I";
                    break;
                case 2:
                    res = "II";
                    break;
                case 3:
                    res = "III";
                    break;
                case 4:
                    res = "IV";
                    break;
                case 5:
                    res = "V";
                    break;
                default:
                    res = String(dm);
            }

            return res;
        })

        public toggleDisplayMode() {
            var dm = ko.unwrap(this.displayMode) + 1;

            if (dm > this.maxDisplayMode)
                dm = this.minDisplayMode;
            this.setDisplayMode(dm);
        };
        public setDisplayMode(dm?: number) {
            if (!$.isNumeric(dm)) {
                if (typeof (this.defaultDisplayMode) === "number")
                    dm = this.defaultDisplayMode;
                else if (typeof (this.defaultDisplayMode) === "function")
                    dm = this.defaultDisplayMode();
            }
            else if (dm < this.minDisplayMode)
                dm = this.minDisplayMode;
            else if (dm > this.maxDisplayMode)
                dm = this.maxDisplayMode;

            this.displayMode(dm);
        };
    }

    export function setDictionaryValue(dict: KnockoutObservable<Dictionary<string>>, key: string, value: string, keepNull?: boolean) {
        var dictObj = ko.unwrap(dict);

        if (typeof key !== "string" || key === "")
            return;

        if (value === undefined || (value === null && keepNull !== true)) {
            if (dictObj) {
                delete dictObj[key];
                dict(dictObj);
            }
        }
        else {
            if (dictObj == null) dictObj = {};

            dictObj[key] = value;

            dict(dictObj);
        }
    }

    export const pushStateSupported = history && history.pushState;
    export function pushState(url: string, data: any, desc: string, replace?: boolean) {

        if (!pushStateSupported) return;

        if (replace == null) {
            var tmp = url;
            if (tmp && utils.startsWithIgnoreCase(tmp, location.origin))
                tmp = tmp.substr(location.origin.length);

            replace = utils.equalsIgnoreCase(tmp, location.pathname + location.search);
            if (!replace && tmp && tmp != "/") {
                var ix = tmp.indexOf("?");

                if (ix == -1) {
                    if (!location.search) {
                        tmp = tmp.substr(0, tmp.length - 1);
                        replace = utils.equalsIgnoreCase(tmp, location.pathname);
                    }
                }
                else if (ix > 1 && tmp.charAt(ix - 1) == "/") {
                    var q = tmp.substr(ix);
                    tmp = tmp.substr(0, ix - 2) + q;


                    replace = utils.equalsIgnoreCase(tmp, location.pathname + location.search);
                }
            }
        }
        if (replace)
            history.replaceState(data, desc, url);
        else
            history.pushState(data, desc, url);
    }

    export function getDateDxFormat(type: "date" | "time" | "datetime"): DevExpress.ui.format {
        var format = "L";

        if (equalsIgnoreCase(type, "time"))
            format = "LT";
        else if (equalsIgnoreCase(type, "datetime"))
            format = "L LT";


        return {
            formatter: raw => moment(raw).format(format),
            parser: raw => { let m = moment(raw, format); return m.isValid() ? m.toDate() : null }
        };

    }

    export namespace math {

        export function roundDecimals(amount: number, dec: number) {
            var to = Math.pow(10, -dec);
            return roundTo(amount, to);
        }

        export function roundTo(amount: number, to: number) {
            if (!amount || typeof (amount) != "number") return 0;
            if (!to || typeof (to) != "number") return amount;

            return Math.round(amount / to) * to;
        }

    }

    export namespace formatting {
        export type numFormatDef = {
            //readonly divPercent: boolean;
            readonly formatter: KnockoutReadonlyComputed<{ (val: number): string }>;
            readonly parser: KnockoutReadonlyComputed<{ (val: string): number }>;
        }
        type formatContext = {
            format?: string;
            numFormatter?: (val: number) => string;
            durFormatter?: (val: moment.Duration) => string;
            dateFormatter?: (val: moment.Moment | Date) => string;
        }

        const mvPhRegex = /{([a-z0-9]+)(?::([^}]+))?}/i;
        var numberFormatRegex = /^([A-Z])([0-9]*)$/i
        var numFormatDict = new utils.SimpleStringDictionary<numFormatDef>();

        export interface IValueFormatter<T> {
            prepareFormatter(format: string): (val: T) => string;
            formatValue(value: T, format?: string): string;
        }
        export interface IMultiValueFormatter<T> extends IValueFormatter<T> {
            getFormatter(name: string): IValueFormatter<T>;
        }

        export abstract class ValueFormatterBase<T> implements IValueFormatter<T>{

            abstract prepareFormatter(format: string): (val: T) => string;
            formatValue(value: T, format?: string): string {
                return this.prepareFormatter(format)(value);
            }

            formatDefault(value: any): string {
                return value != null ? value.toString() : "";
            }

        }

        export abstract class MultiValueFormatterBase<T> extends ValueFormatterBase<T> implements IMultiValueFormatter<T>{

            defaultFormat: string;

            abstract getFormatter(name: string): IValueFormatter<T>;

            prepareFormatter(format: string): (val: T) => string {

                if (format == null) format == this.defaultFormat;

                if (!format)
                    return this.formatDefault;

                var parts: (string | { (val: T): string })[] = [];
                var r = new RegExp(mvPhRegex.source, "ig");
                var ix = 0;
                var m: RegExpMatchArray

                while (m = r.exec(format)) {
                    if (m.index > ix) {
                        parts.push(format.substr(ix, m.index - ix));
                    }

                    var f = this.getFormatter(m[1]);
                    if (f) parts.push(f.prepareFormatter(m[2]));

                    ix = m.index + m[0].length;
                }
                if (ix < format.length)
                    parts.push(format.substr(ix));

                return v => {
                    let res = "";
                    parts.forEach(p => {
                        if (typeof p === "string")
                            res += p;
                        else
                            res += p(v);
                    });

                    return res;
                }
            }

            prepareValue(name: string, format?: string): (val: T) => string {
                var f = this.getFormatter(name);

                if (f) return f.prepareFormatter(format);

                return v => "";
            }
        }

        export class ValueFormatterWrapper<T, TVal> extends ValueFormatterBase<T>{
            constructor(private readonly valFunc: { (val: T): TVal }, public readonly formatter?: IValueFormatter<TVal>, public defFormat?: string | { (val: T): string }) {
                super();

                if (this.formatter == null)
                    this.formatter = <IValueFormatter<any>>defaultFormatter;
            }

            prepareFormatter(format: string): (val: T) => string {
                if ((typeof (format) == "string" && format) || typeof (this.defFormat) !== "function") {
                    let baseFormatter = this.formatter.prepareFormatter(format || <string>this.defFormat);

                    return v => {
                        if (v == null) return "";

                        var val = this.valFunc(v);

                        return (baseFormatter || this.formatDefault)(val);
                    }
                }
                else {
                    var formatFunc = <{ (val: T): string }>this.defFormat;
                    let baseFormatter: { (val: TVal): string } = null;

                    return v => {
                        if (!v) return "";

                        var f2 = formatFunc(v);
                        if (f2 != format) {
                            baseFormatter = this.formatter.prepareFormatter(f2);
                            format = f2;
                        }

                        var val = this.valFunc(v);

                        return (baseFormatter || this.formatDefault)(val);
                    }
                }
            }
        }

        export class MultiValueFormatterWrapper<T, TVal> extends MultiValueFormatterBase<T>{
            private wrappers: Dictionary<IValueFormatter<T> | false> = {};

            constructor(private readonly valFunc: { (val: T): TVal }, public readonly formatter: IMultiValueFormatter<TVal>, getFormatterName: (name: string) => string) {
                super();

                this.formatter

                if (getFormatterName)
                    this.getFormatterName = getFormatterName;

            }

            getFormatterName(name: string): string {
                return name;
            }

            getFormatter(name: string): IValueFormatter<T> {
                name = this.getFormatterName(name);

                if (!name) return null;

                var res = this.wrappers[name];
                if (res === false) return null;
                else if (!res) {
                    var f = this.formatter.getFormatter(name);

                    res = this.wrappers[name] = new ValueFormatterWrapper(this.valFunc, f);
                }

                return res;
            }
        }

        export class ListFormatter<TItems, T = TItems[]> extends ValueFormatterBase<T>{
            constructor(readonly itemFormatter?: IValueFormatter<TItems>, getItemsFunc?: (val: T) => TItems[]) {
                super();

                if (this.itemFormatter == null)
                    this.itemFormatter = <IValueFormatter<any>>defaultFormatter;
                if (getItemsFunc)
                    this.getItems = getItemsFunc;
            }

            protected getItems(val: T): TItems[] {
                if ($.isArray(val))
                    return val;

                return null;
            }

            prepareFormatter(format: string): (val: T) => string {

                var f = this.itemFormatter.prepareFormatter(format);

                return val => {
                    var items = this.getItems(val);
                    if (items) {
                        var parts = $.map(items, v => f(v) || null);

                        return parts.join(", ") || "";
                    }

                    return "";
                }
            }
        }

        export class DictionaryMultiValueFormatter<T> extends MultiValueFormatterBase<T>{

            constructor(private readonly vals: Dictionary<IValueFormatter<T>>) {
                super();

                if (this.vals == null) this.vals = {};
            }

            getFormatter(name: string): IValueFormatter<T> {
                if (typeof name !== "string" || name == "") return null;

                return this.vals[name] || null;
            }

            getVals(): KeyValuePair<string, IValueFormatter<T>>[] {
                return $.map(this.vals, (pv, pn) => {
                    if (typeof (pn) === "string")
                        return { key: pn, value: pv };
                });
            }
        }

        export class SimpleMultiValueFormatter extends MultiValueFormatterBase<MappableObject | Array<any>>{

            getValue(name: string | number, val: any) {
                return (name && val) ? val[name] : null;
            }

            getFormatter(name: string): IValueFormatter<any[] | MappableObject> {
                return new ValueFormatterWrapper(val => this.getValue(name, val));
            }
        }

        export class MultiValueFormatterBuilder<T> {
            private vals: Dictionary<IValueFormatter<T>> = {};
            private lastName: string = null;

            addFormatter(name: string, formatter: IValueFormatter<T>) {
                if (typeof name !== "string" || name == "") {
                    this.lastName = null;
                    return;
                }
                else {
                    if (formatter == null)
                        delete this.vals[name];
                    else
                        this.vals[name] = formatter;
                }
                this.lastName = name;

                return this;
            }

            addListFormatter<TItem>(name: string, getItemsFunc: (val: T) => TItem[], formatter: IValueFormatter<TItem>) {
                if (typeof name !== "string" || name == "") {
                    this.lastName = null;
                    return;
                }
                else {
                    this.addFormatter(name, new ListFormatter<TItem, T>(formatter, getItemsFunc));
                }

                return this;
            }

            addDictionaryFormatter(formatter: DictionaryMultiValueFormatter<T>, prefix?: string, suffix?: string) {
                var self = this;
                prefix = prefix || "";
                suffix = suffix || "";

                formatter.getVals().forEach(kvp => {
                    self.addFormatter(prefix + kvp.key + suffix, kvp.value);
                });

                return this;
            }

            addDictionaryListFormatter<TItem>(getItemsFunc: (val: T) => TItem[], formatter: DictionaryMultiValueFormatter<TItem>, prefix?: string, suffix?: string) {
                var self = this;
                prefix = prefix || "";
                suffix = suffix || "";

                formatter.getVals().forEach(kvp => {
                    self.addListFormatter(prefix + kvp.key + suffix, getItemsFunc, kvp.value);
                });

                return this;
            }

            addWrapper<TVal>(name: string, valFunc: { (val: T): TVal }, formatter?: IValueFormatter<TVal>, defFormat?: string | { (val: T): string }) {
                if (typeof name !== "string" || name == "") return;

                this.addFormatter(name, new ValueFormatterWrapper(valFunc, formatter, defFormat));

                return this;
            }

            addDictionaryWrapper<TVal>(valFunc: { (val: T): TVal }, formatter: DictionaryMultiValueFormatter<TVal>, prefix?: string, suffix?: string) {
                var self = this;
                prefix = prefix || "";
                suffix = suffix || "";

                formatter.getVals().forEach(kvp => {
                    self.addWrapper(prefix + kvp.key + suffix, valFunc, kvp.value);
                });

                return this;
            }

            addStatic(name: string, valFunc: { (val: T): string }) {
                if (typeof name !== "string" || name == "") return;

                this.addFormatter(name, createStaticFormatter(valFunc));

                return this;
            }

            addSimple(name: string, valFunc: { (format: string): { (val: T): string } }) {
                if (typeof name !== "string" || name == "") return;

                this.addFormatter(name, createSimpleFormatter(valFunc));

                return this;
            }

            addAlias(name: string, src?: string) {
                if (typeof name !== "string" || name == "") return;

                src = src || this.lastName;
                var f: IValueFormatter<T> = null;
                if (src)
                    f = this.vals[src];

                this.addFormatter(name, f);

                return this;
            }

            build(): DictionaryMultiValueFormatter<T> {
                var vals = this.vals;

                return new DictionaryMultiValueFormatter(vals);
            }

        }

        export function getNumberFormatter(format: string | Globalize.NumberFormatterOptions): numFormatDef {
            var key: string = null;
            var nf: Globalize.NumberFormatterOptions = null;
            var cf: Globalize.CurrencyFormatterOptions = null;
            var divPercent = false;
            if (format)
                if (typeof (format) === "string") {

                    let [success, res] = numFormatDict.tryGet(format);
                    if (success)
                        return res;
                    else
                        key = format

                    let m = numberFormatRegex.exec(format);
                    if (m) {
                        nf = {
                            style: "decimal"
                        };
                        if (utils.equalsIgnoreCase(m[1], "P"))
                            nf.style = "percent";
                        else if (utils.equalsIgnoreCase(m[1], "W")) {
                            nf.style = "percent";
                            divPercent = true;
                        }
                        else if (utils.equalsIgnoreCase(m[1], "C")) {
                            cf = {}
                        }
                        var dec = parseInt(m[2]);
                        if (!isNaN(dec) && dec >= 0) {
                            nf.maximumFractionDigits = nf.minimumFractionDigits = dec;
                            if (cf)
                                cf.maximumFractionDigits = cf.minimumFractionDigits = dec;
                        }
                    }
                }
                else if (typeof format === "object")
                    nf = format;

            if (!nf)
                nf = { minimumFractionDigits: 2, maximumFractionDigits: 2 };

            var curr = "EUR";// TODO GetDefaultCurrency
            let res = {
                formatter: ko.pureComputed(() => {
                    var g = localization.globalize();

                    var formatter = cf ? g.currencyFormatter(curr, cf) : g.numberFormatter(nf);
                    if (!divPercent) return formatter;
                    else
                        return (n: number) => {
                            if (typeof (n) == "number")
                                n = n / 100;
                            return formatter(n);
                        };
                }),
                parser: ko.pureComputed(() => {
                    var parser = localization.globalize().numberParser(nf);
                    if (!divPercent)
                        return parser;
                    else
                        return (str: string) => {
                            var n = parser(str);
                            if (!isNaN(n)) n = n * 100;
                            return n;
                        };
                })
            };

            if (key)
                numFormatDict.add(key, res, true);

            return res;
        }

        export const numFormatter = new (class NumberFormatter extends ValueFormatterBase<number>{

            prepareFormatter(format: string): (val: number) => string {
                format = format || "N2";
                var valFormatter = getNumberFormatter(format);

                if (!valFormatter)
                    return this.formatDefault;

                return val => {
                    if (val == null) return "";

                    var f = ko.unwrap(valFormatter.formatter);

                    return f ? f(val) : val.toString();
                }
            }
        })();


        export const durFormatter = new (class NumberFormatter extends ValueFormatterBase<moment.Duration>{

            prepareFormatter(format: string): (val: moment.Duration) => string {

                // TODO Define/Implement Formatting for Durations

                var durFormatter: { (dur: moment.Duration): string } = null;
                //var dFormatter: { (days: number): string } = null;

                if (format == "t") {
                    let f = numFormatter.prepareFormatter("N0");
                    durFormatter = v => {
                        var res = "";
                        var part = "";
                        var n = v.hours();
                        if (n) {
                            part = f(n);
                            res = part + ":";
                        }

                        n = v.minutes();
                        part = f(n);
                        if (part.length == 1) part = "0" + part;
                        res += part;

                        n = v.seconds();
                        part = f(n);
                        if (part.length == 1) part = "0" + part;
                        res += ":" + part;

                        return res;
                    }
                }
                else if (format == "hm") {
                    let f = numFormatter.prepareFormatter("N0");
                    durFormatter = v => {
                        var res = "";
                        var part = "";
                        var n = Math.floor(v.asHours());

                        part = f(n);
                        res = part + ":";

                        n = v.minutes();
                        part = f(n);
                        if (part.length == 1) part = "0" + part;
                        res += part;

                        return res;
                    }
                }
                else if (format) {
                    let dFormatter = numFormatter.prepareFormatter(format);
                    durFormatter = v => dFormatter(v.asDays());
                }


                return val => {
                    if (!(moment.isDuration(val) && val.isValid())) return "";

                    if (durFormatter)
                        return durFormatter(val);

                    //if (dFormatter)
                    //    return dFormatter(val.asDays());
                    else
                        return val.humanize();
                }
            }
        })();

        export const dateFormatter = new (class DateFormatter extends ValueFormatterBase<moment.Moment | Date>{

            prepareFormatter(format: string): (val: moment.Moment | Date) => string {

                format = format || "L";

                // Q> Add Support for .Net-Style FormatStrings?
                switch (format) {
                    case "d": format = "L"; break;
                    case "D": format = "LL"; break;
                    case "g": format = "L LT"; break;
                    case "G": format = "L LTS"; break;
                }

                return val => {
                    if (val instanceof Date) val = moment(val);

                    if (!(moment.isMoment(val) && val.isValid())) return "";

                    localization.locale();
                    return val.format(format);
                }
            }
        })();

        export const defaultFormatter = new (class DefaultFormatter extends ValueFormatterBase<string | number | moment.Moment | moment.Duration | boolean>{

            prepareFormatter(format: string): (val: string | number | moment.Moment | moment.Duration | boolean) => string {
                var ctx: formatContext = { format: format };

                return val => this.formatBase(val, ctx);
            }


            formatBase(val: string | number | moment.Moment | moment.Duration | boolean, formatCtx: formatContext): string {


                let format = formatCtx.format;


                if (val == null)
                    return "";
                else if (typeof (val) === "boolean")
                    return String(val);
                else if (typeof (val) === "number") {
                    let nFormatter = formatCtx.numFormatter;
                    if (nFormatter === undefined)
                        nFormatter = formatCtx.numFormatter = numFormatter.prepareFormatter(format);

                    return nFormatter ? nFormatter(val) : val.toString();
                }
                else if (val instanceof Date || moment.isMoment(val)) {
                    let dFormatter = formatCtx.dateFormatter;
                    if (dFormatter === undefined)
                        dFormatter = formatCtx.dateFormatter = dateFormatter.prepareFormatter(format);

                    return dFormatter ? dFormatter(val) : val.toString();
                }
                else if (moment.isDuration(val)) {
                    let dFormatter = formatCtx.durFormatter;
                    if (dFormatter === undefined)
                        dFormatter = formatCtx.durFormatter = durFormatter.prepareFormatter(format);

                    return dFormatter ? dFormatter(val) : val.toString();
                }
                else
                    return val.toString();
            }
        })();

        export function createStaticFormatter<T>(func: { (val: T): string }): IValueFormatter<T> {

            return {
                prepareFormatter: f => func,
                formatValue: (v, f) => func(v)
            };
        }
        export function createSimpleFormatter<T>(func: { (format: string): { (val: T): string } }): IValueFormatter<T> {
            return {
                prepareFormatter: func,
                formatValue: (v, f) => func(f)(v)
            };
        }
        export function createDynamicFormatter<T>(formatter: IValueFormatter<T>, formatStringFunc: { (val: T): string }): IValueFormatter<T> {
            if (!formatter)
                formatter = <any>defaultFormatter;

            return createSimpleFormatter(format => {
                if (typeof format == "string" && format)
                    return formatter.prepareFormatter(format);
                else
                    return val => {
                        format = formatStringFunc(val);
                        return formatter.prepareFormatter(format)(val);
                    }

            });
        }

    }

    export namespace htmlHelpers {
        const lbRegExpr = /(?:\r\n|\r|\n)/g;


        export function lb2br(str: string) {
            if (typeof (str) == "string")
                return str.replace(lbRegExpr, '<br/>')
            return "";
        }

    }


    export function splitSearchTerms(st: string | viewModels.ISearchViewModel) {
        if (typeof st === "string")
            st = { term: st, type: viewModels.StringSearchTypeValues.Contains };


        var res: ISearchTerm[] = [];

        if (st && st.term) {
            var t = ko.unwrap(st.term);
            if (typeof t === "string") {
                let type = ko.unwrap(st.type) || viewModels.StringSearchTypeValues.Contains;
                let parts = t.split(/(?:\s|\+)+/);

                parts.forEach(p => {
                    if (!p || p === "-") return;

                    var tmp: ISearchTerm = {
                        type: type,
                        term: p,
                        isNegated: false
                    };

                    if (p.charAt(0) === "-") {
                        tmp.term = p.substr(1);
                        tmp.isNegated = true;
                    }

                    res.push(tmp);

                });

            }
        }


        return res;
    }

    export function createTextHighlighter(terms: ISearchTerm[], highlightClass?: string): ITextHighlighter {

        if (!terms || terms.length == 0)
            return null;

        else return new DefaultHighlighter(terms, highlightClass || "text-danger bg-info");
    }

    /**
     * Checks whether the Text contains the Term
     * @param st term to search
     * @param txt text
     * @description
     * This function doesn't check whether a term is negated?
     */
    export function checkSearchTerm(st: ISearchTerm, txt: string): boolean {
        var found = false;

        switch (st.type) {
            case viewModels.StringSearchTypeValues.BeginsWith:
                found = utils.startsWithIgnoreCase(txt, st.term);
                break;
            case viewModels.StringSearchTypeValues.EndsWith:
                found = utils.endsWithIgnoreCase(txt, st.term);
                break;
            case viewModels.StringSearchTypeValues.Equals:
                found = utils.equalsIgnoreCase(txt, st.term);
                break;
            case viewModels.StringSearchTypeValues.ContainsNot:
                found = !utils.containsIgnoreCase(txt, st.term);
                break;
            default:
                found = utils.containsIgnoreCase(txt, st.term);
                break;
        }

        return found;
    }

    export function getMatches(st: ISearchTerm, txt: string): [number, number][] {
        var res: [number, number][] = [];

        switch (st.type) {
            case viewModels.StringSearchTypeValues.BeginsWith:
                if (utils.startsWithIgnoreCase(txt, st.term))
                    res.push([0, st.term.length]);
                break;
            case viewModels.StringSearchTypeValues.EndsWith:
                if (utils.endsWithIgnoreCase(txt, st.term))
                    res.push([txt.length - st.term.length, st.term.length]);
                break;
            case viewModels.StringSearchTypeValues.Equals:
                if (utils.equalsIgnoreCase(txt, st.term)) {
                    res.push([0, txt.length]);
                }
                break;
            case viewModels.StringSearchTypeValues.ContainsNot:
                break;
            default:
                res.push(...utils.getIndexesIgnoreCase(txt, st.term).map<[number, number]>(i => [i, st.term.length]));
                break;
        }

        return res;
    }

    export class DefaultHighlighter implements ITextHighlighter {
        readonly highlightClass: KnockoutObservable<string>;
        constructor(private readonly terms: ISearchTerm[], highlightClass: string) {
            this.highlightClass = ko.observable(highlightClass);

            if (terms)
                this.terms = terms.filter(t => t.isNegated == (t.type == viewModels.StringSearchTypeValues.ContainsNot));

        }

        private static readonly entityMap: Dictionary<string> = {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#39;',
            '/': '&#x2F;',
            '`': '&#x60;',
            '=': '&#x3D;'
        };

        static escapeHtml(txt: string) {
            return String(txt).replace(/[&<>"'`=\/]/g, function fromEntityMap(s) {
                return DefaultHighlighter.entityMap[s];
            });
        }


        getHighlightHtml(txt: string): string {
            txt = ko.unwrap(txt);
            if (!txt) return null;

            var matches: [number, number][] = [];

            // Find all matches
            this.terms.forEach(t => {
                matches.push(...getMatches(t, txt));
            })

            if (matches.length == 0)
                return this.generateNormalPart(txt);

            matches = this.combineMatches(matches);

            return this.generateMarkup(txt, matches);
        }
        generateMarkup(txt: string, matches: [number, number][]): string {
            let result: string = "";
            let ix = 0;

            matches.forEach(m => {
                if (m[0] > ix) {
                    let l = m[0] - ix;
                    if (l != 0) {
                        result += this.generateNormalPart(txt.substr(ix, l));
                    }
                }

                if (m[1] != 0)
                    result += this.generateHighlightPart(txt.substr(m[0], m[1]));
                ix = m[0] + m[1];
            });

            if (ix < txt.length) {
                result += this.generateNormalPart(txt.substr(ix));
            }

            return result;

        }
        generateHighlightPart(txt: string): string {
            return "<span class=\"" + this.highlightClass() + "\">" + DefaultHighlighter.escapeHtml(txt) + "</span>";
        }
        generateNormalPart(txt: string): string {
            return "<span>" + DefaultHighlighter.escapeHtml(txt) + "</span>";
        }
        /**
         * Sort matches and combine overlapping matches
         * @param matches
         */
        combineMatches(matches: [number, number][]): [number, number][] {

            matches = matches.sort((a, b) => a[0] - b[0]);
            let matches2: [number, number][] = [];
            let ix = 0, l = 0, e = 0;

            matches.forEach(m => {
                if (l == 0) {
                    ix = m[0];
                    l = m[1];
                    e = ix + l;
                }
                else if (m[0] <= e) {
                    e = m[0] + m[1];
                    l = e - ix;
                }
                else {
                    matches2.push([ix, l]);
                    ix = m[0];
                    l = m[1];
                    e = ix + l;
                }
            });
            if (l !== 0)
                matches2.push([ix, l]);

            return matches2;
        }
    }
}